'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
var camelCase = _interopDefault(require('lodash/camelCase'));
var upperFirst = _interopDefault(require('lodash/upperFirst'));

function SvgAccountCcpa(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.8.4A2.6 2.6 0 018.4 3v1.257H3.2V3A2.6 2.6 0 015.8.4zm0 1.2A1.4 1.4 0 017.2 3v1.245H4.4V3a1.4 1.4 0 011.4-1.4z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 7.4a4.2 4.2 0 11-8.4 0 4.2 4.2 0 018.4 0zM4.4 6.048l.43-.848h1.256l-.481 1.522L7.6 8.847l-.232.18v.811L7.06 10l-.776-.162-.198-.404-1.256-.751V8.29l-.215-1.046-.215-.522v-.674z",
      fill: "currentColor"
    })
  );
}
SvgAccountCcpa.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgAccountCcpa"
};

function SvgAccountEmailPref(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 2a1 1 0 011-1h8a1 1 0 011 1v4.05A2.5 2.5 0 007.05 9H1a1 1 0 01-1-1V2zm1 .5v1L5 6l4-2.5v-1L5 5 1 2.5z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M9.5 6.417a2.083 2.083 0 100 4.166 2.083 2.083 0 000-4.166zm1.042 2.291h-.834v.834h-.416v-.834h-.834v-.416h.834v-.834h.416v.834h.834v.416z",
      fill: "currentColor"
    })
  );
}
SvgAccountEmailPref.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgAccountEmailPref"
};

function SvgAccountLink(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.668 3.21a.865.865 0 01-1.196 0 .802.802 0 010-1.159C8.352.231 11.6 1.523 11.6 4.11c0 .778-.313 1.508-.88 2.058l-1.424 1.38a3.07 3.07 0 01-4.248 0 .802.802 0 010-1.16.865.865 0 011.196 0 1.341 1.341 0 001.856 0l1.424-1.379c.248-.24.384-.56.384-.899 0-1.12-1.409-1.704-2.24-.899zM2.476 6.992c-.248.24-.384.56-.384.899 0 1.13 1.418 1.695 2.24.899a.865.865 0 011.196 0c.33.32.33.839 0 1.159a3.045 3.045 0 01-2.124.851C.733 10.8-.601 7.656 1.28 5.833l1.424-1.38a3.07 3.07 0 014.248 0c.33.32.33.84 0 1.16a.865.865 0 01-1.196 0 1.341 1.341 0 00-1.856 0l-1.424 1.38z",
      fill: "currentColor"
    })
  );
}
SvgAccountLink.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgAccountLink"
};

function SvgAccountPassword(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M.8 1.766C4.083 1.646 6 0 6 0s1.917 1.645 5.2 1.766c0 0 .024 9.049-5.2 10.234C.752 10.815.8 1.766.8 1.766zm6.79 3.496h.338c.062 0 .112.05.112.113V8.22a.453.453 0 01-.45.456H4.433a.453.453 0 01-.45-.456V5.375c0-.062.05-.113.112-.113h.338v-.456c0-.878.708-1.593 1.578-1.593.87 0 1.579.715 1.579 1.593v.456zM6.345 7.754a.115.115 0 00.029-.09l-.072-.65a.459.459 0 00-.27-.828.459.459 0 00-.27.828l-.073.65a.115.115 0 00.114.128h.457a.114.114 0 00.085-.038zM5.096 5.262v-.456c0-.502.402-.91.896-.91.493 0 .895.408.895.91v.456h-1.79z",
      fill: "currentColor"
    })
  );
}
SvgAccountPassword.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgAccountPassword"
};

function SvgAccountProfile(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.829 9.687L7.697 8.605a.826.826 0 01-.45-.738V7.02c.06-.07.13-.158.203-.263.29-.416.51-.874.662-1.355a.678.678 0 00.475-.646V3.85a.68.68 0 00-.223-.502v-1.31S8.628 0 5.909 0C3.19 0 3.455 2.038 3.455 2.038v1.31a.68.68 0 00-.224.501v.906c0 .238.124.448.309.57.223.985.807 1.694.807 1.694v.827c0 .302-.162.58-.424.724l-1.99 1.102A1.82 1.82 0 001 11.267V12h9.818v-.689a1.82 1.82 0 00-.99-1.624z",
      fill: "currentColor"
    })
  );
}
SvgAccountProfile.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgAccountProfile"
};

function SvgAccount(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M6.006.75c.305 0 .62.061.944.183.325.12.608.273.85.457.243.184.442.387.599.61.156.223.234.432.234.628v1.876c0 .446-.093.943-.281 1.49-.188.548-.465.962-.833 1.244a.878.878 0 00-.164.193.772.772 0 00-.117.487.73.73 0 00.434.598l3.272 1.549.024.005.047.018.058.035.065.053.059.076.04.117.012.153v.727l-10.498.012v-.762c0-.196.105-.34.316-.434l3.297-1.56a.714.714 0 00.428-.593.695.695 0 00-.276-.674c-.36-.29-.64-.71-.839-1.261-.199-.552-.299-1.042-.299-1.473V2.628c0-.259.13-.534.387-.827a3.197 3.197 0 011.01-.745A2.78 2.78 0 016.004.75zm0-.75c-.54 0-1.073.131-1.601.393A3.746 3.746 0 003.12 1.402c-.328.41-.492.819-.492 1.226v1.876c0 .509.119 1.093.357 1.754.239.66.593 1.183 1.062 1.566L.75 9.384a.644.644 0 00-.082.035c-.032.016-.09.051-.176.106s-.163.11-.23.164a.935.935 0 00-.18.205.42.42 0 00-.083.23v1.137c0 .203.072.377.217.522A.725.725 0 00.751 12h10.51a.712.712 0 00.522-.217.712.712 0 00.217-.522v-1.138a.457.457 0 00-.076-.24.81.81 0 00-.188-.211 3.378 3.378 0 00-.217-.159 1.206 1.206 0 00-.188-.105l-.07-.024-3.273-1.56c.47-.367.82-.876 1.05-1.525.23-.649.346-1.247.346-1.795V2.628c0-.305-.1-.616-.299-.933a3.42 3.42 0 00-.768-.85 3.981 3.981 0 00-1.091-.61A3.44 3.44 0 006.006 0z",
      fill: "currentColor"
    })
  );
}
SvgAccount.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgAccount"
};

function SvgAdd(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M11.82 6.82h-5v5H5.18v-5h-5V5.18h5v-5h1.64v5h5v1.64z",
      fill: "currentColor"
    })
  );
}
SvgAdd.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgAdd"
};

function SvgArrowRotateRightDollarOutline(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none" }, props),
    React.createElement("path", {
      d: "M12.548 11.288c-.658-.318-1.227-.593-1.227-1.132 0-.539.321-.821.9-.821a1.772 1.772 0 011.287.594l.094.086.857-.974-.079-.083a2.855 2.855 0 00-1.68-.944v-1.2h-1.195v1.229a2.119 2.119 0 00-1.749 2.171c0 1.285 1 1.8 1.887 2.247.713.363 1.328.676 1.328 1.311 0 .592-.344.891-1.022.891a2.68 2.68 0 01-1.672-.706l-.107-.083-.747 1.122.077.073c.562.498 1.26.818 2.005.918v1.2H12.7v-1.24a2.194 2.194 0 001.833-2.266c.003-1.43-1.099-1.963-1.985-2.393z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M21.003 11.848a.575.575 0 00-.1-.244.5.5 0 00-.663-.125.487.487 0 00-.18.206.43.43 0 00-.043.185 1.46 1.46 0 00-.006.175c0 .137 0 .274-.01.41v.046a7.769 7.769 0 01-.15 1.131 8.023 8.023 0 01-.304 1.075c-.063.174-.13.345-.2.514-.07.169-.154.333-.239.5-.085.167-.176.32-.271.476-.095.156-.2.306-.3.455-.1.149-.217.292-.332.432a7.738 7.738 0 01-.746.792 8.205 8.205 0 01-.846.686c-.149.105-.3.2-.457.3a7.91 7.91 0 01-3.133 1.089 8.294 8.294 0 01-1.004.063 8 8 0 010-16c2.093.017 4.1.84 5.6 2.3l-1.19 1.19 1.634.117 1.686.157-.157-1.686-.107-1.645-1.159 1.16a9.124 9.124 0 00-6.312-2.589 9 9 0 104.784 16.621c.154-.097.305-.2.453-.305a8.735 8.735 0 001.234-1.067 8.328 8.328 0 001.024-1.269c.101-.152.2-.306.29-.463a9.487 9.487 0 00.494-.982c.072-.169.14-.342.2-.515s.118-.352.169-.53a7.346 7.346 0 00.239-1.099c.025-.186.053-.377.07-.567.017-.19.033-.422.038-.615.012-.126.01-.253-.006-.379z",
      fill: "currentColor"
    })
  );
}
SvgArrowRotateRightDollarOutline.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgArrowRotateRightDollarOutline"
};

function SvgArrowsRotateOutline(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M8.85 1.382a5.347 5.347 0 012.401 2.922c.06.176.242.283.421.236a.323.323 0 00.23-.411A6.014 6.014 0 009.189.805a6.058 6.058 0 00-4.579-.6 6.115 6.115 0 00-3.64 2.76l-.952-.548.216 1.08.191 1.114 1.065-.393 1.039-.357-.978-.562A5.444 5.444 0 014.779.848a5.384 5.384 0 014.07.534zm-5.7 9.236a5.346 5.346 0 01-2.4-2.922.354.354 0 00-.421-.236.323.323 0 00-.23.411 6.014 6.014 0 002.714 3.324 6.057 6.057 0 004.579.6 6.114 6.114 0 003.639-2.76l.952.548-.216-1.08-.191-1.114-1.065.393-1.039.358.978.561a5.445 5.445 0 01-3.228 2.451 5.384 5.384 0 01-4.07-.534z",
      fill: "currentColor"
    })
  );
}
SvgArrowsRotateOutline.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgArrowsRotateOutline"
};

function SvgBankAccount(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M6 3.652a.744.744 0 100-1.488.744.744 0 000 1.488z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M6.73.245A1.201 1.201 0 006 0c-.266 0-.524.086-.73.245L.306 4.055C-.297 4.518.05 5.44.828 5.44h.21v3.936c-.589.283-.992.861-.992 1.53v.624c0 .125.053.244.146.332a.51.51 0 00.35.137h10.916c.131 0 .258-.05.35-.137a.455.455 0 00.146-.332v-.624c0-.668-.403-1.247-.993-1.53V5.44h.21c.779 0 1.126-.923.522-1.386L6.73.245zm-.833.727a.172.172 0 01.208 0l4.6 3.532h-9.41L5.897.972zm4.072 8.217h-.992V5.441h.992V9.19zm-1.984 0H6.496V5.441h1.489V9.19zm-2.481 0H4.016V5.441h1.488V9.19zm4.631.937c.456 0 .826.35.826.78v.157H1.04v-.156c0-.431.37-.78.826-.78h8.27zM3.023 9.19h-.992V5.441h.992V9.19z",
      fill: "currentColor"
    })
  );
}
SvgBankAccount.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgBankAccount"
};

function SvgBirthdayGift(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M.75 10.75c0 .415.335.75.75.75h3.75V7.75H.75v3zM11.25 4h-.987c.146-.284.237-.598.237-.938A2.066 2.066 0 008.437 1c-.974 0-1.605.5-2.414 1.6C5.215 1.5 4.584 1 3.61 1a2.066 2.066 0 00-2.062 2.063c0 .34.089.653.237.937H.75a.75.75 0 00-.75.75v1.875C0 6.831.169 7 .375 7h11.25A.376.376 0 0012 6.625V4.75a.75.75 0 00-.75-.75zM3.607 4a.937.937 0 110-1.875c.466 0 .811.077 2.018 1.875H3.607zm4.83 0H6.42c1.204-1.793 1.54-1.875 2.018-1.875a.937.937 0 110 1.875zM6.75 11.5h3.75a.75.75 0 00.75-.75v-3h-4.5v3.75z",
      fill: "currentColor"
    })
  );
}
SvgBirthdayGift.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgBirthdayGift"
};

function SvgBusinessContact(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M6 5.5c1.578 0 2.857-1.231 2.857-2.75S7.578 0 6 0C4.422 0 3.143 1.231 3.143 2.75S4.422 5.5 6 5.5zm2.138.7l-1.067 4.112-.714-2.921.714-1.204H4.93l.714 1.204-.714 2.921L3.862 6.2C2.27 6.273 1 7.526 1 9.075v.894C1 10.539 1.48 11 2.071 11H9.93c.59 0 1.07-.462 1.07-1.031v-.894C11 7.526 9.73 6.273 8.138 6.2z",
      fill: "currentColor"
    })
  );
}
SvgBusinessContact.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgBusinessContact"
};

function SvgCaretDown(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M6.649 8.727l4.136-4.396c.488-.52.091-1.331-.65-1.331H1.864a.91.91 0 00-.467.128.822.822 0 00-.319.343.752.752 0 00-.068.448.778.778 0 00.205.412L5.35 8.726a.86.86 0 00.293.202.918.918 0 00.713 0 .86.86 0 00.293-.202z",
      fill: "currentColor"
    })
  );
}
SvgCaretDown.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgCaretDown"
};

function SvgCaretLeft(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M3.273 6.649l4.396 4.136c.52.488 1.331.091 1.331-.65V1.864a.91.91 0 00-.128-.467.822.822 0 00-.343-.319.752.752 0 00-.448-.068.778.778 0 00-.412.205L3.274 5.35a.86.86 0 00-.202.293.918.918 0 000 .713.86.86 0 00.202.293z",
      fill: "currentColor"
    })
  );
}
SvgCaretLeft.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgCaretLeft"
};

function SvgCaretRight(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M8.727 5.351L4.33 1.215C3.81.727 3 1.124 3 1.865v8.272a.91.91 0 00.128.467c.083.14.202.25.343.319.14.068.296.092.448.068a.778.778 0 00.412-.205L8.726 6.65a.86.86 0 00.202-.293.918.918 0 000-.713.86.86 0 00-.202-.293z",
      fill: "currentColor"
    })
  );
}
SvgCaretRight.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgCaretRight"
};

function SvgCaretUp(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M5.351 3.273L1.215 7.67C.727 8.19 1.124 9 1.865 9h8.272a.91.91 0 00.467-.128.822.822 0 00.319-.343.751.751 0 00.068-.448.778.778 0 00-.205-.412L6.65 3.274a.86.86 0 00-.293-.202.918.918 0 00-.713 0 .86.86 0 00-.293.202z",
      fill: "currentColor"
    })
  );
}
SvgCaretUp.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgCaretUp"
};

function SvgCheck(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 6A6 6 0 110 6a6 6 0 0112 0zM9.023 3.728a.562.562 0 00-.81.016L5.607 7.063l-1.57-1.57a.563.563 0 00-.795.794l1.985 1.986a.563.563 0 00.809-.015L9.03 4.514a.563.563 0 00-.008-.787z",
      fill: "currentColor"
    })
  );
}
SvgCheck.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgCheck"
};

function SvgChevronDown(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3.383c0-.051.01-.1.03-.148A.398.398 0 01.4 3c.108 0 .202.036.28.11l5.361 4.994 5.267-4.918a.406.406 0 01.287-.11c.114 0 .21.037.288.11a.352.352 0 01.117.268c0 .105-.04.194-.117.267l-5.56 5.17A.398.398 0 016.04 9a.398.398 0 01-.281-.11L.117 3.646a.356.356 0 01-.088-.126A.358.358 0 010 3.383z",
      fill: "currentColor"
    })
  );
}
SvgChevronDown.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgChevronDown"
};

function SvgChevronLeft(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.617 0a.38.38 0 01.274.117A.402.402 0 016 .4c0 .11-.036.203-.11.281L.897 6.041l4.918 5.267c.073.078.11.174.11.287 0 .114-.037.21-.11.288a.352.352 0 01-.268.117.352.352 0 01-.267-.117L.11 6.323A.398.398 0 010 6.04c0-.11.036-.203.11-.281L5.354.117A.356.356 0 015.481.03.358.358 0 015.617 0z",
      fill: "currentColor"
    })
  );
}
SvgChevronLeft.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgChevronLeft"
};

function SvgChevronRight(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.383 12a.38.38 0 01-.148-.03A.398.398 0 016 11.6c0-.108.036-.202.11-.28l4.994-5.361L6.186.692a.406.406 0 01-.11-.287c0-.114.037-.21.11-.288A.352.352 0 016.454 0c.105 0 .194.04.267.117l5.17 5.56a.4.4 0 01.109.282c0 .11-.036.203-.11.281l-5.245 5.643a.357.357 0 01-.126.088.358.358 0 01-.136.029z",
      fill: "currentColor"
    })
  );
}
SvgChevronRight.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgChevronRight"
};

function SvgChevronUp(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 8.617a.38.38 0 00.117.274A.402.402 0 00.4 9c.11 0 .203-.036.281-.11l5.361-4.994 5.267 4.918c.078.073.174.11.287.11.114 0 .21-.037.288-.11A.352.352 0 0012 8.546a.352.352 0 00-.117-.267l-5.56-5.17A.398.398 0 006.04 3a.398.398 0 00-.281.11L.117 8.354a.356.356 0 00-.088.126.358.358 0 00-.029.136z",
      fill: "currentColor"
    })
  );
}
SvgChevronUp.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgChevronUp"
};

function SvgClock(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 13 13", fill: "none" }, props),
    React.createElement("path", {
      d: "M6 0a6 6 0 100 12A6 6 0 006 0zm2.364 7.844l-.383.523a.107.107 0 01-.15.022L5.616 6.774a.106.106 0 01-.045-.087V3c0-.059.049-.107.108-.107h.644c.059 0 .107.048.107.107v3.315l1.91 1.38a.107.107 0 01.024.15z",
      fill: "currentColor"
    })
  );
}
SvgClock.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgClock"
};

function SvgClose(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M.707 0L0 .707 5.303 6.01 0 11.314l.707.707L6.01 6.718l5.304 5.303.707-.707L6.718 6.01 12.02.707 11.314 0 6.01 5.303.707 0z",
      fill: "currentColor"
    })
  );
}
SvgClose.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgClose"
};

function SvgCompany(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M11.679 11.25h-.536V.562c0-.31-.288-.562-.643-.562h-9C1.145 0 .857.252.857.563V11.25H.321c-.177 0-.321.126-.321.281V12h12v-.469c0-.155-.144-.281-.321-.281zm-8.25-9.469c0-.155.143-.281.321-.281h1.071c.178 0 .322.126.322.281v.938c0 .155-.144.281-.322.281H3.75c-.178 0-.321-.126-.321-.281V1.78zm0 2.25c0-.155.143-.281.321-.281h1.071c.178 0 .322.126.322.281v.938c0 .155-.144.281-.322.281H3.75c-.178 0-.321-.126-.321-.281V4.03zM4.82 7.5H3.75c-.178 0-.321-.126-.321-.281V6.28c0-.155.143-.281.321-.281h1.071c.178 0 .322.126.322.281v.938c0 .155-.144.281-.322.281zm2.036 3.75H5.143V9.281c0-.155.144-.281.321-.281h1.072c.177 0 .321.126.321.281v1.969zM8.57 7.219c0 .155-.143.281-.321.281h-1.07c-.178 0-.322-.126-.322-.281V6.28c0-.155.144-.281.322-.281H8.25c.178 0 .321.126.321.281v.938zm0-2.25c0 .155-.143.281-.321.281h-1.07c-.178 0-.322-.126-.322-.281V4.03c0-.155.144-.281.322-.281H8.25c.178 0 .321.126.321.281v.938zm0-2.25c0 .155-.143.281-.321.281h-1.07c-.178 0-.322-.126-.322-.281V1.78c0-.155.144-.281.322-.281H8.25c.178 0 .321.126.321.281v.938z",
      fill: "currentColor"
    })
  );
}
SvgCompany.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgCompany"
};

function SvgContactAdd(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 13 10", fill: "none" }, props),
    React.createElement("path", {
      d: "M12.675 4.063h-1.3v-1.25a.32.32 0 00-.325-.313h-.65a.32.32 0 00-.325.313v1.25h-1.3a.32.32 0 00-.325.312V5a.32.32 0 00.325.313h1.3v1.25a.32.32 0 00.325.312h.65a.32.32 0 00.325-.313v-1.25h1.3A.32.32 0 0013 5v-.625a.32.32 0 00-.325-.313zM4.55 5c1.436 0 2.6-1.12 2.6-2.5S5.986 0 4.55 0c-1.436 0-2.6 1.12-2.6 2.5S3.114 5 4.55 5zm1.82.625h-.34a3.66 3.66 0 01-2.96 0h-.34C1.223 5.625 0 6.801 0 8.25v.813C0 9.58.437 10 .975 10h7.15c.538 0 .975-.42.975-.938V8.25c0-1.45-1.223-2.625-2.73-2.625z",
      fill: "currentColor"
    })
  );
}
SvgContactAdd.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgContactAdd"
};

function SvgContactAdded(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 13 10", fill: "none" }, props),
    React.createElement("path", {
      d: "M4.55 5c1.436 0 2.6-1.12 2.6-2.5S5.986 0 4.55 0c-1.436 0-2.6 1.12-2.6 2.5S3.114 5 4.55 5zm1.82.625h-.34a3.66 3.66 0 01-2.96 0h-.34C1.223 5.625 0 6.801 0 8.25v.813C0 9.58.437 10 .975 10h7.15c.538 0 .975-.42.975-.938V8.25c0-1.45-1.223-2.625-2.73-2.625zm6.56-2.508l-.564-.549a.248.248 0 00-.341-.002L9.896 4.598l-.924-.895a.248.248 0 00-.341-.002l-.571.545a.225.225 0 00-.002.328l1.66 1.608a.248.248 0 00.34.002l2.87-2.739a.227.227 0 00.003-.328z",
      fill: "currentColor"
    })
  );
}
SvgContactAdded.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgContactAdded"
};

function SvgCreditCard(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M10.998 2H1.002C.448 2 0 2.411 0 2.918v6.735c0 .507.448.918 1.002.918h9.996c.554 0 1.002-.41 1.002-.918V2.918C12 2.411 11.552 2 10.998 2zm-9.87.918h9.745c.069 0 .125.052.125.115v.804H1.002v-.804c0-.063.056-.115.125-.115zm9.745 6.735H1.127c-.069 0-.125-.052-.125-.115V6.286h9.996v3.252c0 .063-.056.115-.125.115zM4 7.74v.765c0 .126-.112.23-.25.23h-1.5c-.138 0-.25-.104-.25-.23V7.74c0-.126.112-.23.25-.23h1.5c.138 0 .25.104.25.23zm4 0v.765c0 .126-.112.23-.25.23H4.917c-.138 0-.25-.104-.25-.23V7.74c0-.126.112-.23.25-.23H7.75c.138 0 .25.104.25.23z",
      fill: "currentColor"
    })
  );
}
SvgCreditCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgCreditCard"
};

function SvgDocCar(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.445 0C1.647 0 1 .647 1 1.445v9.11C1 11.353 1.647 12 2.445 12h6.403c.798 0 1.445-.647 1.445-1.445V2.983L7.457 0H2.445zm2.65 6.818c-.16-.112-.203-.207-.166-.35.019-.001.027.01.037.023.008.012.018.024.036.028a.32.32 0 00-.01-.132c-.026-.055-.082-.067-.115-.024a.137.137 0 00-.01.016c-.01.018-.02.035-.052.027-.039-.01-.05-.039-.055-.07-.005-.045-.03-.077-.055-.11l-.013-.017a1.73 1.73 0 00-.042-.055.492.492 0 01-.117-.21c-.012-.061-.04-.082-.098-.09a57.11 57.11 0 01-.743-.113c-.042-.007-.07.001-.098.036a60.52 60.52 0 01-.571.678c-.032.037-.03.061.001.096.082.093.163.187.238.285.04.05.081.07.144.066l.936-.046.387-.018.241-.013.125-.007zm1.458 1.545c-.011.065.022.072.076.066.174-.02.348-.037.523-.055l.14-.014c.006.026-.008.04-.022.053l-.012.012-.399.482c-.289.35-.578.698-.864 1.048-.053.064-.076.056-.123-.002-.18-.22-.362-.436-.545-.652-.034-.04-.037-.06.009-.094l.835-.632.343-.261a.09.09 0 01.018-.01l.022-.01v.029c.001.016.002.028 0 .04zm-1.056-.755a.4.4 0 00-.097-.222 1.068 1.068 0 01-.041-.06c-.025-.04-.058-.073-.091-.107a.7.7 0 01-.088-.101c-.058-.084-.132-.115-.24-.102-.331.041-.663.077-1 .114l-.387.042a.811.811 0 01.012.02l.015.02.175.21c.174.208.348.415.521.624.033.04.06.042.105.027.337-.112.674-.22 1.012-.328l.011-.003c.065-.02.099-.031.093-.134zm.937.612l-.018.01-.766.516-.261.175-.066.045-.132.088-.004.003c-.022.015-.04.028-.067-.003-.161-.195-.324-.389-.488-.585l-.14-.167.24-.095 1.085-.432c.04-.016.06 0 .082.024.05.053.105.086.184.081.05-.002.11.004.08.086-.008.023.001.039.027.036.091-.011.146.043.2.096.02.02.04.038.06.054.048.036.012.054-.016.068zm1.71-2.246c.01-.017.025-.035.038-.052.03-.04.062-.079.067-.122.007-.048-.033-.086-.071-.123a.506.506 0 01-.042-.043l-.94-1.143-1.192-1.449c-.043-.053-.064-.059-.108-.002-.086.11-.174.22-.271.32-.069.072-.059.111.011.177.61.577 1.218 1.157 1.826 1.737l.467.445.03.037a.167.167 0 00-.048-.02l-.036-.028a3.314 3.314 0 01-.068-.054l-.314-.259a834.07 834.07 0 01-2.046-1.691c-.048-.04-.072-.048-.116.007-.164.202-.332.402-.504.598-.046.053-.031.07.021.099.202.107.401.219.6.33.057.032.112.06.18.052.023-.004.061-.007.06.027-.003.057.034.075.07.092a.394.394 0 01.024.011l1.6.881.509.28c.02.025.047.037.079.05-.013-.003-.025-.009-.036-.014-.014-.007-.027-.014-.043-.016l-2.2-.975v.191c.001.156.002.305-.003.455-.002.077.027.101.097.117.315.07.63.143.945.215l.63.144c.128.029.256.056.383.082l.182.039c-.016.022-.039.018-.06.014l-.01-.002-.787-.121-.483-.075L6.03 6.1l-.269-.04.007.014a.04.04 0 00.01.016l.23.21.46.42c.035.033.072.031.111.03h.004l.038-.002.924-.04c.05-.002.098 0 .147.003a.374.374 0 00-.05.015l-1.04.114.11.1c.088.08.17.153.25.23.043.042.08.044.134.025.153-.051.307-.1.46-.148l.162-.051a.366.366 0 00.113-.032.326.326 0 01.084-.026.643.643 0 01-.048.016.332.332 0 00-.13.06l-.652.257a.858.858 0 00.12.118.487.487 0 01.165.2l.408-.267a.194.194 0 00.043-.013.156.156 0 00-.025.03 12.72 12.72 0 00-.1.078c-.08.062-.158.124-.24.181-.074.051-.074.095-.007.145.046.036.046.066.005.108l-.02.02c-.032.029-.064.059-.057.113.006.045-.014.082-.05.117-.051.051-.02.105.02.148.045.046.062.01.076-.018a.112.112 0 01.012-.021l.238-.287c.134-.164.269-.328.41-.486.106-.12.163-.223.04-.358a.088.088 0 01-.012-.021l-.002-.004-.003-.007-.082-.317c-.01-.099-.008-.197-.006-.296l.002-.047c.029-.142.068-.28.124-.413zm-3.756-1.14c.061.153.022.294-.019.43l-.001.006c-.031.104-.06.198.03.297l-.527-.119.517-.613zm.342-.137c-.084-.038-.126-.057-.162-.048-.035.008-.064.044-.122.117l-.002.006-.002.01h.447a.851.851 0 00-.16-.085zm4.16-1.7h1.131L7.444.28v1.27c0 .798.647 1.445 1.445 1.445z",
      fill: "currentColor"
    })
  );
}
SvgDocCar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgDocCar"
};

function SvgDocContact(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 14 16", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.765 0C1.067 0 .5.567.5 1.265v13.47C.5 15.433 1.067 16 1.765 16h10.47c.698 0 1.265-.567 1.265-1.265V3.977L9.533 0H1.765zm8.432 12.252L8.39 11.37a.672.672 0 01-.38-.602v-.692c.05-.057.108-.13.17-.215a4.02 4.02 0 00.561-1.105.556.556 0 00.402-.527V7.49a.546.546 0 00-.189-.41V6.014S9.18 4.35 6.876 4.35 4.797 6.013 4.797 6.013V7.08a.546.546 0 00-.189.409v.739c0 .194.105.366.261.465.19.803.684 1.382.684 1.382v.675a.67.67 0 01-.359.59l-1.686.9c-.487.259-.79.757-.79 1.3v.598h8.317v-.562a1.48 1.48 0 00-.838-1.325zm.584-8.257h1.97L9.515.72v2.01c0 .7.567 1.266 1.266 1.266z",
      fill: "currentColor"
    })
  );
}
SvgDocContact.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgDocContact"
};

function SvgDocHome(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.445 0C1.647 0 1 .647 1 1.445v9.11C1 11.353 1.647 12 2.445 12h6.403c.798 0 1.445-.647 1.445-1.445V2.983L7.457 0H2.445zm7.576 2.996H8.889a1.445 1.445 0 01-1.445-1.445V.281l2.577 2.715zM7.469 6.698L8.5 7.716v.17h-.688v1.697H6.095V8.565h-.688v1.018H3.688V7.886H3v-.17L5.75 5l1.031 1.019v-.85h.688v1.529z",
      fill: "currentColor"
    })
  );
}
SvgDocHome.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgDocHome"
};

function SvgDocImage(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.5 1.084C1.5.485 1.985 0 2.584 0h5.373l2.836 2.983v7.933c0 .599-.485 1.084-1.084 1.084H2.584A1.084 1.084 0 011.5 10.916V1.084zm7.528 1.912h1.493L7.944.281v1.631c0 .599.486 1.084 1.084 1.084zM4.824 5.818a.818.818 0 11-1.637 0 .818.818 0 011.637 0zM3 9.578h6.543l-2.57-3.636L5.57 8.02l-.702-1.038L3 9.577z",
      fill: "currentColor"
    })
  );
}
SvgDocImage.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgDocImage"
};

function SvgDocMagnifier(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.445 0C1.647 0 1 .647 1 1.445v9.11C1 11.353 1.647 12 2.445 12h6.403c.798 0 1.445-.647 1.445-1.445V2.983L7.457 0H2.445zm7.576 2.996H8.889a1.445 1.445 0 01-1.445-1.445V.281l2.577 2.715zM6.123 9.19c1.19 0 2.158-.94 2.158-2.095C8.28 5.94 7.313 5 6.123 5s-2.159.94-2.159 2.095c0 .52.196.995.52 1.361L3 9.896l.236.23 1.484-1.44c.377.314.868.504 1.403.504zm0-3.889c1.019 0 1.847.805 1.847 1.794s-.828 1.793-1.847 1.793c-1.02 0-1.848-.804-1.848-1.793 0-.99.829-1.794 1.848-1.794z",
      fill: "currentColor"
    })
  );
}
SvgDocMagnifier.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgDocMagnifier"
};

function SvgDocPdf(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.584 0C1.985 0 1.5.485 1.5 1.084v9.832c0 .599.485 1.084 1.084 1.084h7.125c.599 0 1.084-.485 1.084-1.084V2.983L7.957 0H2.584zm7.937 2.996H9.028a1.084 1.084 0 01-1.084-1.084V.281l2.577 2.715zM3.464 9.75h.435v-.9h.39c.525 0 .93-.251.93-.795 0-.57-.394-.758-.93-.758h-.825V9.75zm.435-1.249v-.855h.352c.356 0 .54.101.54.409 0 .3-.172.446-.54.446h-.352zm1.77 1.249h.674c.728 0 1.174-.424 1.174-1.238 0-.81-.446-1.215-1.196-1.215h-.653V9.75zm.434-.353V7.65h.188c.495 0 .78.262.78.862 0 .604-.285.885-.78.885h-.188zm2.337.353h-.435V7.297h1.48v.368H8.44v.694h.888v.367H8.44V9.75z",
      fill: "currentColor"
    })
  );
}
SvgDocPdf.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgDocPdf"
};

function SvgDocPlain(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.445 0C1.647 0 1 .647 1 1.445v9.11C1 11.353 1.647 12 2.445 12h6.403c.798 0 1.445-.647 1.445-1.445V2.983L7.457 0H2.445z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.021 2.996H8.889a1.445 1.445 0 01-1.445-1.445V.281l2.577 2.715z",
      fill: "#fff"
    })
  );
}
SvgDocPlain.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgDocPlain"
};

function SvgDocProgress(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 1.445C1 .647 1.647 0 2.445 0h5.012l2.836 2.983v7.572c0 .798-.647 1.445-1.445 1.445H2.445A1.445 1.445 0 011 10.555v-9.11zm7.89 1.551h1.131L7.444.281v1.27c0 .798.647 1.445 1.445 1.445zM5.68 5C4.203 5 3 6.216 3 7.71s1.203 2.71 2.681 2.71c1.479 0 2.682-1.216 2.682-2.71S7.16 5 5.68 5zm0 4.927c-1.21 0-2.193-.995-2.193-2.217 0-1.223.984-2.217 2.193-2.217h.013v2.221l1.823 1.209A2.188 2.188 0 015.68 9.927z",
      fill: "currentColor"
    })
  );
}
SvgDocProgress.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgDocProgress"
};

function SvgDocUpload(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.445 0C1.647 0 1 .647 1 1.445v9.11C1 11.353 1.647 12 2.445 12h6.403c.798 0 1.445-.647 1.445-1.445V2.983L7.457 0H2.445zm3.77 8.553a.355.355 0 00.252-.106.364.364 0 00.104-.256V6.382h.567a.354.354 0 00.33-.223.366.366 0 00-.078-.394l-1.637-1.66a.355.355 0 00-.506 0L3.61 5.766a.363.363 0 00.252.617h.567v1.81c0 .095.037.187.104.255a.355.355 0 00.253.106h1.428zm-2.858.723h4.286c.095 0 .185.039.252.106a.364.364 0 010 .512.355.355 0 01-.252.106H3.357a.355.355 0 01-.252-.106.364.364 0 010-.512.355.355 0 01.252-.106zm5.532-6.28h1.132L7.444.281v1.27c0 .798.647 1.445 1.445 1.445z",
      fill: "currentColor"
    })
  );
}
SvgDocUpload.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgDocUpload"
};

function SvgDownload(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M10.75 4H8.083V0h-4v4H1.417l4.666 5.333L10.75 4zm-10 6.667h10.667V12H.75v-1.333z",
      fill: "currentColor"
    })
  );
}
SvgDownload.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgDownload"
};

function SvgEdit(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.434 7.781L9.649 0l.017.018c.12-.043.51-.05 1.45.923.94.973.914 1.358.865 1.474v.001a.122.122 0 01-.027.042l-.008-.009-8.233 7.799c-.087-.432-.405-.963-.807-1.417-.485-.55-1.046-.942-1.472-1.05zM.9 8.991l.09-.295.11-.369c-.006-.081.006-.139.034-.165h.001c.019-.017.055-.02.082-.02.268 0 .846.332 1.39.947.523.592.723 1.1.733 1.357.003.08-.011.136-.041.162-.024.02-.064.025-.094.025a.394.394 0 01-.063-.008l-.013-.002-.426.05-.316.037-1.448.168v-.001l.001-.001a.476.476 0 00-.135-.336c-.046-.053-.167-.169-.318-.18L.9 8.992zm-.433 1.583a.049.049 0 00-.032.01l-.356.295c-.038.032-.125.224-.05.31.03.034.081.046.135.046a.37.37 0 00.186-.046l.356-.294.002-.005.002-.005c.027-.037-.001-.123-.07-.203-.056-.063-.12-.102-.165-.106l-.008-.002z",
      fill: "currentColor"
    })
  );
}
SvgEdit.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgEdit"
};

function SvgEmail(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M10.8 1H1.2C.54 1 .006 1.563.006 2.25L0 9.75C0 10.438.54 11 1.2 11h9.6c.66 0 1.2-.563 1.2-1.25v-7.5C12 1.562 11.46 1 10.8 1zm0 2.5L6 6.625 1.2 3.5V2.25L6 5.375l4.8-3.125V3.5z",
      fill: "currentColor"
    })
  );
}
SvgEmail.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgEmail"
};

function SvgEmptyStar(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 13 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.488.511a.846.846 0 011.554 0l1.342 3.116 3.377.313a.846.846 0 01.48 1.478L9.694 7.657l.746 3.309a.846.846 0 01-1.257.913l-2.917-1.732-2.917 1.732a.846.846 0 01-1.257-.913l.746-3.31L.29 5.419a.846.846 0 01.48-1.478l3.378-.313L5.488.51zm.777.335L4.923 3.96a.846.846 0 01-.698.508l-3.378.313 2.548 2.24a.842.842 0 01.267.82l-.746 3.31L5.833 9.42a.846.846 0 01.864 0l2.917 1.732-.746-3.31a.846.846 0 01.267-.82l2.548-2.24-3.377-.313a.846.846 0 01-.7-.508L6.267.846z",
      fill: "currentColor"
    })
  );
}
SvgEmptyStar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgEmptyStar"
};

function SvgEmptyVerify(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M4.42.803l1.338.573.248.108.249-.108L7.592.803l.746 1.26.14.236.267.064 1.42.325-.133 1.452-.026.274.179.204.961 1.102-.961 1.102-.179.203.026.274.134 1.453-1.42.324-.268.064-.14.236-.746 1.255-1.337-.574L6 9.95l-.255.108-1.337.58-.746-1.255-.14-.236-.267-.063-1.42-.325.133-1.459.026-.274-.179-.203L.854 5.72l.961-1.109.179-.203-.026-.274-.134-1.459 1.42-.318.268-.058.14-.235.746-1.255.012-.006zM7.854 0L6 .796 4.146 0 3.115 1.739l-1.969.44.185 2.018L0 5.727l1.331 1.521-.185 2.02 1.969.445 1.031 1.74L6 10.65l1.854.796 1.031-1.739 1.969-.446-.185-2.013L12 5.726l-1.331-1.522.184-2.013-1.968-.446L7.854 0z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M8.815 3.713a.463.463 0 00-.662 0L5.095 6.771 3.893 5.567a.477.477 0 10-.675.675l1.445 1.446a.598.598 0 00.854 0l3.3-3.3a.477.477 0 00.14-.33.474.474 0 00-.14-.332v-.013z",
      fill: "currentColor"
    })
  );
}
SvgEmptyVerify.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgEmptyVerify"
};

function SvgError(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M6.591 6.591V2.986H5.41V6.59h1.18zm0 2.423V7.803H5.41v1.211h1.18zM6 0a5.9 5.9 0 013.043.822 5.687 5.687 0 012.135 2.135A5.9 5.9 0 0112 6a5.9 5.9 0 01-.822 3.043 5.686 5.686 0 01-2.135 2.135A5.9 5.9 0 016 12a5.9 5.9 0 01-3.043-.822 5.795 5.795 0 01-2.135-2.15A5.875 5.875 0 010 6c0-1.087.274-2.096.822-3.029A5.905 5.905 0 012.972.822 5.875 5.875 0 016 0z",
      fill: "currentColor"
    })
  );
}
SvgError.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgError"
};

function SvgEsignCalendar(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M2.823 1h-.705a.353.353 0 00-.353.353v1.412c0 .195.158.353.353.353h.705a.353.353 0 00.353-.353V1.353A.353.353 0 002.823 1zm7.059 0h-.706a.353.353 0 00-.353.353v1.412c0 .195.159.353.353.353h.706a.353.353 0 00.353-.353V1.353A.353.353 0 009.882 1z",
      fill: "currentColor",
      stroke: "currentColor"
    }),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 4a1 1 0 011-1h10a1 1 0 011 1v7a1 1 0 01-1 1H1a1 1 0 01-1-1V4zm3.882.882H2.471a.353.353 0 00-.353.353v1.412c0 .195.158.353.353.353h1.411a.353.353 0 00.353-.353V5.235a.353.353 0 00-.353-.353zm1.412 0h1.412c.195 0 .353.158.353.353v1.412A.353.353 0 016.706 7H5.294a.353.353 0 01-.353-.353V5.235c0-.195.158-.353.353-.353zm4.235 0H8.118a.353.353 0 00-.353.353v1.412c0 .195.158.353.353.353h1.411a.353.353 0 00.353-.353V5.235a.353.353 0 00-.353-.353zm-7.058 3.53h1.411c.195 0 .353.158.353.353v1.411a.353.353 0 01-.353.353H2.471a.353.353 0 01-.353-.353V8.765c0-.195.158-.353.353-.353zm4.235 0H5.294a.353.353 0 00-.353.353v1.411c0 .195.158.353.353.353h1.412a.353.353 0 00.353-.353V8.765a.353.353 0 00-.353-.353zm1.412 0h1.411c.195 0 .353.158.353.353v1.411a.353.353 0 01-.353.353H8.118a.353.353 0 01-.353-.353V8.765c0-.195.158-.353.353-.353z",
      fill: "currentColor"
    })
  );
}
SvgEsignCalendar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgEsignCalendar"
};

function SvgEsignCheckbox(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#esign-checkbox_svg__a)" },
      React.createElement("rect", {
        x: 0.5,
        y: 0.5,
        width: 11.085,
        height: 11,
        rx: 1.5,
        stroke: "currentColor"
      }),
      React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.222 5.068l1.745 1.746 4.068-4.068 1.222 1.221L5.005 9.22l-.04-.04-.038.037L2 6.29l1.222-1.222z",
        fill: "currentColor"
      })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "esign-checkbox_svg__a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h12v12H0z" })
      )
    )
  );
}
SvgEsignCheckbox.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgEsignCheckbox"
};

function SvgEsignInitials(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M1.877 7.339V2H3.68c.277 0 .536.027.775.082.24.054.446.144.62.269.175.12.31.28.409.482.103.201.155.451.155.75 0 .409-.098.738-.294.988-.19.25-.446.43-.767.54l1.273 2.228h-1.06L3.64 5.249h-.817v2.09h-.946zm.946-2.841h.76c.364 0 .642-.076.832-.229.196-.152.294-.38.294-.685 0-.31-.098-.525-.294-.645-.19-.12-.468-.18-.832-.18h-.76v1.739zm3.885 2.841V2h1.681c.294 0 .566.027.817.082.255.054.476.147.66.277.186.13.33.302.433.514.104.207.156.466.156.776 0 .294-.052.55-.156.767-.103.218-.247.4-.432.547-.18.142-.395.248-.645.319a3.098 3.098 0 01-.8.098h-.767v1.959h-.947zm.947-2.719h.693c.784 0 1.176-.323 1.176-.971 0-.337-.103-.569-.31-.694-.202-.13-.501-.196-.898-.196h-.661V4.62zM0 8.505h12v1.166H0V8.505z",
      fill: "currentColor"
    })
  );
}
SvgEsignInitials.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgEsignInitials"
};

function SvgEsignText(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#esign-text_svg__a)" },
      React.createElement("path", {
        d: "M4.043 11.551a.293.293 0 01-.238-.102.538.538 0 01-.068-.272c.011-.17.045-.272.102-.306.057-.034.164-.051.323-.051.329 0 .572-.057.731-.17a.743.743 0 00.289-.442c.045-.181.074-.414.085-.697V1.402H4.094c-.385.011-.686.096-.901.255-.204.147-.363.374-.476.68-.102.295-.193.72-.272 1.275-.011.09-.08.164-.204.221a.934.934 0 01-.391.085.536.536 0 01-.289-.085.322.322 0 01-.119-.255l.051-2.397c0-.272.153-.408.459-.408h8.313c.295 0 .442.136.442.408l.068 2.397a.308.308 0 01-.136.255.536.536 0 01-.289.085.935.935 0 01-.391-.085c-.113-.057-.176-.13-.187-.221-.09-.567-.187-.997-.289-1.292-.102-.295-.26-.516-.476-.663-.215-.159-.516-.244-.901-.255H6.95v8.109c.011.283.034.516.068.697a.83.83 0 00.306.442c.159.113.402.17.731.17h.102c.102 0 .176.023.221.068.057.034.09.13.102.289a.456.456 0 01-.085.272c-.045.068-.119.102-.221.102a43.073 43.073 0 00-2.006-.051c-.68 0-1.388.017-2.125.051z",
        fill: "currentColor"
      })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "esign-text_svg__a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h12v12H0z" })
      )
    )
  );
}
SvgEsignText.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgEsignText"
};

function SvgFaWarning(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 512 512" }, props),
    React.createElement("path", {
      fill: "currentColor",
      d: "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
    })
  );
}
SvgFaWarning.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgFaWarning"
};

function SvgFeatureReferenceChecks(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 16", fill: "none" }, props),
    React.createElement("path", {
      d: "M4.64 4.64C5.9213 4.64 6.96 3.6013 6.96 2.32C6.96 1.0387 5.9213 0 4.64 0C3.3587 0 2.32 1.0387 2.32 2.32C2.32 3.6013 3.3587 4.64 4.64 4.64Z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M5 8.2C5.00195 7.75631 5.13621 7.32329 5.3856 6.95633C5.63499 6.58936 5.98819 6.30514 6.4 6.14C5.84568 5.92235 5.25551 5.81042 4.66 5.81C3.43534 5.80726 2.25904 6.28776 1.38654 7.14715C0.514045 8.00654 0.0157991 9.17544 0 10.4V11H5V8.2Z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M12.87 7.06H7.2C6.89765 7.06 6.60769 7.18011 6.3939 7.3939C6.18011 7.60769 6.06 7.89765 6.06 8.2V13.87C6.06264 14.1706 6.18391 14.458 6.39741 14.6696C6.61092 14.8813 6.89938 15 7.2 15H12.87C13.1689 14.9974 13.4548 14.8775 13.6661 14.6661C13.8775 14.4548 13.9974 14.1689 14 13.87V8.2C14 7.89938 13.8813 7.61092 13.6696 7.39741C13.458 7.18391 13.1706 7.06264 12.87 7.06ZM12 10.43L9.89 12.55C9.82963 12.6105 9.75793 12.6584 9.67899 12.6912C9.60006 12.7239 9.51545 12.7408 9.43 12.7408C9.34455 12.7408 9.25994 12.7239 9.18101 12.6912C9.10208 12.6584 9.03037 12.6105 8.97 12.55L7.97 11.6C7.85027 11.4768 7.78329 11.3118 7.78329 11.14C7.78329 10.9682 7.85027 10.8032 7.97 10.68C8.02968 10.6183 8.10116 10.5692 8.18018 10.5357C8.25921 10.5022 8.34417 10.485 8.43 10.485C8.51584 10.485 8.60079 10.5022 8.67982 10.5357C8.75884 10.5692 8.83032 10.6183 8.89 10.68L9.38 11.17L11.03 9.52C11.0897 9.45831 11.1612 9.40925 11.2402 9.37574C11.3192 9.34224 11.4042 9.32497 11.49 9.32497C11.5758 9.32497 11.6608 9.34224 11.7398 9.37574C11.8188 9.40925 11.8903 9.45831 11.95 9.52C12.0148 9.57536 12.0676 9.64327 12.1054 9.71964C12.1431 9.79601 12.165 9.87924 12.1697 9.9643C12.1744 10.0494 12.1617 10.1345 12.1326 10.2145C12.1034 10.2946 12.0583 10.3679 12 10.43Z",
      fill: "currentColor"
    })
  );
}
SvgFeatureReferenceChecks.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgFeatureReferenceChecks"
};

function SvgFeatureRentEstimates(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 15", fill: "none" }, props),
    React.createElement("path", {
      d: "M10.7648 4.8001H8.58483C8.4778 4.80007 8.375 4.84189 8.29839 4.91663C8.22178 4.99137 8.17744 5.0931 8.17483 5.2001V14.4001C8.17744 14.5071 8.22178 14.6088 8.29839 14.6836C8.375 14.7583 8.4778 14.8001 8.58483 14.8001H10.7748C10.8809 14.8001 10.9827 14.758 11.0577 14.6829C11.1327 14.6079 11.1748 14.5062 11.1748 14.4001V5.2301C11.179 5.17425 11.1715 5.11814 11.1527 5.06539C11.1338 5.01265 11.1041 4.96445 11.0655 4.92391C11.0268 4.88338 10.9801 4.85141 10.9283 4.83008C10.8765 4.80876 10.8208 4.79854 10.7648 4.8001Z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M6.71483 6.8001H4.52482C4.41874 6.8001 4.317 6.84224 4.24198 6.91726C4.16697 6.99227 4.12483 7.09401 4.12483 7.2001V14.4001C4.12483 14.5062 4.16697 14.6079 4.24198 14.6829C4.317 14.758 4.41874 14.8001 4.52482 14.8001H6.71483C6.76819 14.8014 6.82128 14.7921 6.87097 14.7726C6.92066 14.7531 6.96595 14.7238 7.00415 14.6865C7.04236 14.6493 7.07272 14.6047 7.09345 14.5555C7.11417 14.5063 7.12484 14.4535 7.12483 14.4001V7.2001C7.12484 7.14672 7.11417 7.09387 7.09345 7.04468C7.07272 6.99549 7.04236 6.95094 7.00415 6.91366C6.96595 6.87639 6.92066 6.84713 6.87097 6.82763C6.82128 6.80813 6.76819 6.79877 6.71483 6.8001Z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M2.70482 8.8001H0.514825C0.408738 8.8001 0.306997 8.84224 0.231982 8.91726C0.156968 8.99227 0.114825 9.09401 0.114825 9.2001V14.4001C0.114825 14.5062 0.156968 14.6079 0.231982 14.6829C0.306997 14.758 0.408738 14.8001 0.514825 14.8001H2.70482C2.81185 14.8001 2.91465 14.7583 2.99126 14.6836C3.06787 14.6088 3.11221 14.5071 3.11482 14.4001V9.2401C3.11896 9.18379 3.11141 9.12723 3.09267 9.07397C3.07392 9.02071 3.04438 8.9719 3.00588 8.93059C2.96739 8.88928 2.92078 8.85637 2.86898 8.83391C2.81717 8.81146 2.76129 8.79995 2.70482 8.8001Z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M0.364825 6.7001C0.428058 6.72706 0.496087 6.74095 0.564825 6.74095C0.633564 6.74095 0.701592 6.72706 0.764825 6.7001L9.16482 2.2101L8.96482 2.7901C8.94291 2.85509 8.93408 2.92378 8.93882 2.9922C8.94357 3.06062 8.9618 3.12743 8.99247 3.18878C9.02315 3.25012 9.06565 3.30479 9.11754 3.34964C9.16943 3.39449 9.22968 3.42863 9.29482 3.4501C9.35621 3.47739 9.42264 3.49149 9.48982 3.49149C9.557 3.49149 9.62344 3.47739 9.68482 3.4501C9.74781 3.42268 9.80386 3.3815 9.84885 3.32959C9.89384 3.27768 9.92664 3.21635 9.94483 3.1501L10.5848 1.2601C10.6142 1.19753 10.6295 1.12924 10.6295 1.0601C10.6295 0.990959 10.6142 0.922669 10.5848 0.8601C10.5547 0.798907 10.5127 0.744369 10.4612 0.699711C10.4096 0.655053 10.3497 0.621182 10.2848 0.6001L8.42482 9.94878e-05H8.26482C8.15494 -0.00209232 8.04739 0.0319849 7.95882 0.0970596C7.87024 0.162134 7.80558 0.25458 7.77482 0.3601C7.73363 0.490075 7.74513 0.63103 7.80686 0.752606C7.86858 0.874182 7.97559 0.966652 8.10483 1.0101L8.79482 1.2301L8.60483 1.3301L0.274825 5.7401C0.214076 5.77258 0.160387 5.8168 0.116874 5.87021C0.0733609 5.92361 0.0408922 5.98513 0.0213542 6.05119C0.0018161 6.11724 -0.0044022 6.18652 0.00306032 6.25501C0.0105228 6.32349 0.0315177 6.3898 0.064825 6.4501C0.0955 6.50977 0.137869 6.56265 0.189409 6.6056C0.240949 6.64855 0.300605 6.68069 0.364825 6.7001Z",
      fill: "currentColor"
    })
  );
}
SvgFeatureRentEstimates.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgFeatureRentEstimates"
};

function SvgFeatureRentersInsurance(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 18 20", fill: "none" }, props),
    React.createElement("path", {
      d: "M17 3C16.9923 2.86247 16.9313 2.73335 16.83 2.64C16.7808 2.59419 16.7222 2.5597 16.6583 2.53897C16.5944 2.51824 16.5267 2.51176 16.46 2.52C13.3 2.76 10.91 2.05 9.36999 0.380004C9.271 0.283493 9.13823 0.229477 8.99999 0.229477C8.86174 0.229477 8.72897 0.283493 8.62999 0.380004C7.07999 2 4.68999 2.76 1.52999 2.51C1.46329 2.50176 1.3956 2.50824 1.33168 2.52897C1.26775 2.5497 1.20915 2.58419 1.15999 2.63C1.06 2.72745 1.0025 2.86041 0.999986 3C0.679986 11.74 3.30999 17.38 8.79999 19.76C8.86625 19.7703 8.93372 19.7703 8.99999 19.76C9.06632 19.7694 9.13365 19.7694 9.19999 19.76C14.68 17.37 17.31 11.73 17 3ZM8.99999 5.86C9.3283 5.86 9.64925 5.95736 9.92223 6.13976C10.1952 6.32217 10.408 6.58142 10.5336 6.88475C10.6593 7.18807 10.6921 7.52185 10.6281 7.84385C10.564 8.16586 10.4059 8.46165 10.1738 8.6938C9.94163 8.92596 9.64584 9.08406 9.32384 9.14811C9.00183 9.21216 8.66806 9.17929 8.36473 9.05364C8.06141 8.928 7.80215 8.71524 7.61975 8.44225C7.43734 8.16926 7.33999 7.84832 7.33999 7.52C7.33999 7.07974 7.51488 6.65752 7.82619 6.34621C8.1375 6.0349 8.55973 5.86 8.99999 5.86V5.86ZM5.66999 13.32C5.66999 12.4395 6.01977 11.595 6.64239 10.9724C7.26501 10.3498 8.10947 10 8.98999 10C9.87051 10 10.715 10.3498 11.3376 10.9724C11.9602 11.595 12.31 12.4395 12.31 13.32H5.66999Z",
      fill: "currentColor"
    })
  );
}
SvgFeatureRentersInsurance.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgFeatureRentersInsurance"
};

function SvgFeatureRequestDocs(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 16", fill: "none" }, props),
    React.createElement("path", {
      d: "M13.34 3.15L10.34 0.15C10.2951 0.102367 10.2405 0.0648648 10.18 0.04C10.1234 0.0143851 10.0621 0.000765895 9.99999 0H0.99999C0.86473 0 0.73501 0.0537319 0.639366 0.149375C0.543723 0.245019 0.48999 0.37474 0.48999 0.51V15.51C0.495161 15.6418 0.551168 15.7664 0.646257 15.8578C0.741346 15.9491 0.868125 16.0001 0.99999 16H13C13.0665 16 13.1323 15.9868 13.1937 15.961C13.255 15.9353 13.3106 15.8975 13.3571 15.85C13.4037 15.8025 13.4403 15.7462 13.4648 15.6844C13.4894 15.6226 13.5013 15.5565 13.5 15.49V3.49C13.4919 3.36043 13.4347 3.23884 13.34 3.15V3.15ZM5.18999 6.34L6.54999 5C6.60737 4.9413 6.6752 4.89382 6.74999 4.86C6.91131 4.80027 7.08868 4.80027 7.24999 4.86C7.32478 4.89382 7.39261 4.9413 7.44999 5L8.80999 6.36C8.89358 6.45048 8.94974 6.56285 8.97192 6.68402C8.99411 6.80518 8.9814 6.93016 8.93529 7.04439C8.88918 7.15862 8.81157 7.25739 8.71148 7.3292C8.6114 7.40101 8.49297 7.4429 8.36999 7.45C8.19951 7.44978 8.03534 7.38554 7.90999 7.27L7.63999 7V9.67C7.63999 9.83974 7.57256 10.0025 7.45254 10.1225C7.33252 10.2426 7.16973 10.31 6.99999 10.31C6.83025 10.31 6.66747 10.2426 6.54744 10.1225C6.42742 10.0025 6.35999 9.83974 6.35999 9.67V7L6.08999 7.26C6.03211 7.3264 5.95939 7.37822 5.87772 7.41123C5.79606 7.44424 5.70775 7.45753 5.61999 7.45C5.45402 7.44711 5.2959 7.37883 5.17999 7.26C5.12017 7.19897 5.07297 7.12675 5.04109 7.04746C5.00921 6.96817 4.99328 6.88338 4.99421 6.79793C4.99514 6.71247 5.01291 6.62805 5.0465 6.54947C5.0801 6.47089 5.12886 6.39971 5.18999 6.34V6.34ZM9.71999 12.19H4.27999C4.11025 12.19 3.94747 12.1226 3.82744 12.0025C3.70742 11.8825 3.63999 11.7197 3.63999 11.55C3.63999 11.466 3.65654 11.3827 3.68871 11.3051C3.72087 11.2274 3.76801 11.1569 3.82744 11.0975C3.88687 11.038 3.95742 10.9909 4.03507 10.9587C4.11272 10.9266 4.19594 10.91 4.27999 10.91H9.71999C9.80404 10.91 9.88726 10.9266 9.96491 10.9587C10.0426 10.9909 10.1131 11.038 10.1725 11.0975C10.232 11.1569 10.2791 11.2274 10.3113 11.3051C10.3434 11.3827 10.36 11.466 10.36 11.55C10.36 11.634 10.3434 11.7173 10.3113 11.7949C10.2791 11.8726 10.232 11.9431 10.1725 12.0025C10.1131 12.062 10.0426 12.1091 9.96491 12.1413C9.88726 12.1734 9.80404 12.19 9.71999 12.19V12.19ZM9.99999 4C9.86473 4 9.73501 3.94627 9.63937 3.85062C9.54372 3.75498 9.48999 3.62526 9.48999 3.49V1L12.49 4H9.99999Z",
      fill: "currentColor"
    })
  );
}
SvgFeatureRequestDocs.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgFeatureRequestDocs"
};

function SvgFeatureSuggestFeature(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 16 38", fill: "none" }, props),
    React.createElement("path", {
      d: "M25.681 31.3556L25.4374 30.8741C25.1963 30.4003 24.7872 30.0334 24.2901 29.845C23.793 29.6565 23.2435 29.6601 22.7489 29.8549L17.0031 32.1462H12.9004C12.8072 32.1462 12.7149 32.1278 12.6287 32.0921C12.5426 32.0564 12.4641 32.0041 12.3982 31.9382C12.3318 31.8723 12.2795 31.7938 12.2441 31.7072C12.2087 31.6206 12.1909 31.5278 12.1922 31.4343C12.1941 31.2477 12.2697 31.0695 12.4023 30.9383C12.5349 30.8071 12.7139 30.7335 12.9004 30.7335H15.7442C16.3056 30.7335 16.8442 30.5106 17.2412 30.1136C17.6382 29.7166 17.8612 29.178 17.8612 28.6166C17.8612 28.0551 17.6382 27.5167 17.2412 27.1197C16.8442 26.7227 16.3056 26.4996 15.7442 26.4996H4.39315C4.28337 26.499 4.17507 26.524 4.07665 26.5726L4.02588 26.5989V34.8569H4.28064L8.18872 37.6203C8.30899 37.7045 8.45221 37.7495 8.59899 37.7495H18.4832C18.609 37.7497 18.7327 37.716 18.8411 37.6521L24.8565 34.1282C25.319 33.8559 25.6611 33.4185 25.8141 32.904C25.967 32.3896 25.9196 31.8363 25.681 31.3556V31.3556Z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M16.8711 21.9789H11.1701C10.9217 21.9789 10.6835 22.0776 10.5078 22.2533C10.3322 22.4289 10.2334 22.6672 10.2334 22.9157C10.2334 23.1641 10.3322 23.4023 10.5078 23.5779C10.6835 23.7536 10.9217 23.8524 11.1701 23.8524H16.8711C17.1196 23.8524 17.3577 23.7536 17.5334 23.5779C17.7091 23.4023 17.8078 23.1641 17.8078 22.9157C17.8078 22.6672 17.7091 22.4289 17.5334 22.2533C17.3577 22.0776 17.1196 21.9789 16.8711 21.9789Z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M21.8991 6.82405C21.6644 4.93323 20.7183 3.20279 19.2532 1.98474C17.7881 0.766692 15.914 0.152509 14.0121 0.267052C12.5197 0.164931 11.0317 0.523285 9.74954 1.29387C8.46736 2.06445 7.45266 3.21011 6.84244 4.57591C6.20315 6.07153 5.95367 7.70481 6.11749 9.32305C6.28131 10.9413 6.85309 12.4916 7.77915 13.8287C8.61461 15.1702 8.97241 16.7546 8.79453 18.325C8.80043 18.9487 9.05156 19.5449 9.49364 19.9849C9.93572 20.4249 10.5332 20.6732 11.1569 20.6761H16.8952C17.5032 20.6748 18.0873 20.4393 18.5262 20.0185C18.9651 19.5978 19.2251 19.0242 19.2521 18.4168C19.2572 16.7414 19.7245 15.0999 20.6027 13.6732C21.888 11.6372 22.3515 9.18892 21.8991 6.82405V6.82405ZM17.6428 8.62063L14.0832 12.1801C13.9834 12.2805 13.8649 12.3602 13.7342 12.4146C13.6035 12.469 13.4632 12.497 13.3217 12.497C13.1801 12.497 13.04 12.469 12.9093 12.4146C12.7786 12.3602 12.6599 12.2805 12.5601 12.1801L10.9547 10.5746C10.7596 10.3712 10.6518 10.0994 10.6547 9.8176C10.6576 9.53576 10.7708 9.26633 10.9701 9.06704C11.1694 8.86774 11.439 8.75446 11.7208 8.75156C12.0027 8.74865 12.2744 8.85634 12.4778 9.05148L13.3208 9.89638L16.1215 7.08624C16.3262 6.89652 16.5965 6.79348 16.8755 6.79878C17.1546 6.80407 17.4207 6.91736 17.6181 7.11471C17.8154 7.31207 17.9286 7.57821 17.9339 7.85727C17.9392 8.13632 17.8361 8.40655 17.6464 8.61126L17.6428 8.62063Z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M1.99874 25.9579H0.874685C0.667752 25.9579 0.5 26.1256 0.5 26.3326V35.0103C0.5 35.2172 0.667752 35.385 0.874685 35.385H1.99874C2.20567 35.385 2.37343 35.2172 2.37343 35.0103V26.3326C2.37343 26.1256 2.20567 25.9579 1.99874 25.9579Z",
      fill: "currentColor"
    })
  );
}
SvgFeatureSuggestFeature.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgFeatureSuggestFeature"
};

function SvgFeatureTenantScreening(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.87 0.15L12.87 3.15C12.9623 3.24765 13.0157 3.37571 13.02 3.51V8.28C12.533 8.1007 12.0189 8.006 11.5 8C10.5487 7.9869 9.6225 8.3051 8.88 8.9C8.59473 8.5866 8.24731 8.3358 7.85999 8.1637C7.47272 7.9916 7.05377 7.9018 6.63 7.9C6.22339 7.9 5.82068 7.9803 5.44519 8.1362C5.06958 8.2921 4.72858 8.5206 4.44153 8.8086C4.15442 9.0966 3.927 9.4384 3.77234 9.8144C3.61761 10.1905 3.5387 10.5934 3.53998 11V12.07H7V12.53C6.99127 13.1954 7.13031 13.8544 7.40698 14.4597C7.68372 15.0649 8.09113 15.6012 8.59998 16.03H0.51001C0.374756 16.03 0.244995 15.9763 0.149353 15.8806C0.0537109 15.785 0 15.6553 0 15.52V0.52C0.00769043 0.390011 0.0647583 0.26786 0.159607 0.178619C0.254395 0.0893707 0.379761 0.0397701 0.51001 0.039999H9.51001C9.57581 0.0249996 9.64423 0.0249996 9.71002 0.039999C9.77063 0.0648594 9.82507 0.102369 9.87 0.15ZM5.76617 6.8437C6.0224 7.0128 6.323 7.102 6.63 7.1C7.03943 7.0974 7.43097 6.9329 7.7196 6.6425C8.00812 6.3521 8.16998 5.95936 8.16998 5.55C8.16998 5.24301 8.0788 4.94294 7.90808 4.68784C7.7373 4.43273 7.49463 4.23407 7.21082 4.11705C6.927 4.00004 6.61493 3.96993 6.3139 4.03055C6.013 4.09118 5.73682 4.2398 5.52039 4.45757C5.30408 4.67534 5.15723 4.95246 5.09857 5.25379C5.03992 5.55511 5.07202 5.86707 5.19092 6.1501C5.30969 6.4332 5.51001 6.6745 5.76617 6.8437ZM9.15631 3.85776C9.2514 3.94912 9.37811 4.0001 9.51001 4H12L9 1V3.51C9.00519 3.64176 9.06122 3.7664 9.15631 3.85776ZM15.024 12.405C15.0431 13.1951 14.7951 13.9685 14.32 14.6L15.71 16L15.72 15.97C15.8064 16.0672 15.8524 16.1938 15.8486 16.3238C15.8448 16.4538 15.7914 16.5774 15.6994 16.6694C15.6075 16.7614 15.4838 16.8147 15.3538 16.8186C15.2238 16.8224 15.0972 16.7764 15 16.69L13.59 15.3C12.989 15.7562 12.2546 16.0022 11.5 16C10.7098 15.9966 9.94379 15.7267 9.32599 15.2338C8.70831 14.741 8.2749 14.0541 8.09607 13.2843C7.91718 12.5146 8.00342 11.707 8.34058 10.9923C8.6778 10.2775 9.2464 9.6976 9.95422 9.3461C10.6621 8.9947 11.4678 8.8925 12.2409 9.0559C13.0141 9.2194 13.7095 9.6389 14.2146 10.2467C14.7197 10.8546 15.0048 11.615 15.024 12.405ZM10.1226 14.5775C10.53 14.851 11.0093 14.998 11.5 15C11.83 15 12.1568 14.9347 12.4614 14.8078C12.766 14.6809 13.0425 14.495 13.2749 14.2607C13.5073 14.0264 13.691 13.7485 13.8155 13.4429C13.94 13.1372 14.0027 12.81 14 12.48C13.9941 11.9893 13.8433 11.5112 13.5666 11.1059C13.2898 10.7006 12.8995 10.3862 12.4446 10.202C11.9897 10.0178 11.4905 9.9722 11.0098 10.0708C10.529 10.1695 10.0881 10.408 9.74249 10.7564C9.39691 11.1048 9.16193 11.5475 9.06708 12.029C8.97229 12.5106 9.02191 13.0094 9.20972 13.4628C9.39752 13.9162 9.71509 14.304 10.1226 14.5775Z",
      fill: "currentColor"
    })
  );
}
SvgFeatureTenantScreening.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgFeatureTenantScreening"
};

function SvgFeatureListingPage(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({
      width: "33",
      height: "30",
      viewBox: "0 0 33 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    React.createElement("path", {
      d: "M32.0614 0H0.938567C0.689644 0 0.450872 0.0988766 0.274856 0.274956C0.0988408 0.451035 0 0.689894 0 0.938908C0 1.18792 0.0988408 1.42667 0.274856 1.60274C0.450872 1.77882 0.689644 1.87782 0.938567 1.87782H7.20819V7.43241H2.92454C2.52627 7.43241 2.14432 7.59068 1.8627 7.87241C1.58107 8.15413 1.42286 8.53621 1.42286 8.93464V28.4977C1.42286 28.8961 1.58107 29.2783 1.8627 29.56C2.14432 29.8417 2.52627 30 2.92454 30H30.0623C30.4606 30 30.8426 29.8417 31.1242 29.56C31.4058 29.2783 31.564 28.8961 31.564 28.4977V8.93464C31.564 8.53621 31.4058 8.15413 31.1242 7.87241C30.8426 7.59068 30.4606 7.43241 30.0623 7.43241H25.7993V1.87782H32.0614C32.3104 1.87782 32.5491 1.77882 32.7251 1.60274C32.9011 1.42667 33 1.18792 33 0.938908C33 0.689894 32.9011 0.451035 32.7251 0.274956C32.5491 0.0988766 32.3104 0 32.0614 0ZM24.6392 18.4852C24.5367 18.4986 24.4327 18.4746 24.3464 18.4176L22.8729 17.3622L22.8203 25.7636C22.8198 25.8775 22.7744 25.9866 22.6939 26.0672C22.6134 26.1477 22.5043 26.1931 22.3904 26.1936H18.4635V21.2775C18.4635 21.0858 18.3874 20.9019 18.2518 20.7663C18.1163 20.6308 17.9324 20.5545 17.7408 20.5545H15.2273C15.0356 20.5545 14.8518 20.6308 14.7163 20.7663C14.5807 20.9019 14.5046 21.0858 14.5046 21.2775V26.1936H10.5157C10.4017 26.1936 10.2923 26.1483 10.2117 26.0676C10.1311 25.987 10.0858 25.8776 10.0858 25.7636L10.1384 17.3434L8.63666 18.4176C8.55978 18.472 8.46808 18.5015 8.37389 18.502C8.27861 18.5014 8.18592 18.4708 8.10912 18.4144C8.03232 18.358 7.97533 18.2787 7.9462 18.1879C7.91707 18.0971 7.91728 17.9995 7.94689 17.9089C7.9765 17.8183 8.03397 17.7394 8.11107 17.6834L16.2222 11.8622C16.2988 11.8072 16.3907 11.7776 16.485 11.7776C16.5789 11.7779 16.6706 11.8067 16.7478 11.8602L24.8664 17.6815C24.9635 17.7516 25.029 17.8571 25.0487 17.9753C25.0684 18.0934 25.0406 18.2147 24.9715 18.3125C24.932 18.3637 24.8818 18.4056 24.8244 18.4355C24.767 18.4653 24.7038 18.4823 24.6392 18.4852ZM23.9222 7.43241H9.09283V1.87782H23.9222V7.43241Z",
      fill: "#405369"
    })
  );
}
SvgFeatureListingPage.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgFeatureListingPage"
};

function SvgFeatureClientManager(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({
      width: "27",
      height: "32",
      viewBox: "0 0 27 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.2104 25.8312L18.5266 22.9476C17.7923 22.5751 17.3281 21.8131 17.3281 20.9799V18.717C17.4876 18.5328 17.6709 18.2955 17.8661 18.0154C18.6408 16.9057 19.2263 15.6842 19.6327 14.4024C20.3617 14.1748 20.8984 13.4913 20.8984 12.6792V10.2642C20.8984 9.73283 20.6657 9.25766 20.3034 8.92559V5.43396C20.3034 5.43396 21.0097 0 13.7579 0C6.50554 0 7.21245 5.43396 7.21245 5.43396V8.92559C6.85007 9.25766 6.61741 9.73283 6.61741 10.2642V12.6792C6.61741 13.3156 6.94706 13.8753 7.44035 14.1989C8.03479 16.8266 9.59261 18.717 9.59261 18.717V20.9238C9.59261 21.7286 9.15942 22.4694 8.46263 22.8546L3.15427 25.7932C1.62084 26.6415 0.666992 28.2723 0.666992 30.0444V32H26.8488V30.1627C26.8488 28.3285 25.8271 26.6518 24.2104 25.8312Z",
      fill: "#405369"
    })
  );
}
SvgFeatureClientManager.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgFeatureClientManager"
};

function SvgFeatureAgentProfile(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({
      width: "28",
      height: "32",
      viewBox: "0 0 28 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    React.createElement("path", {
      d: "M9.31633 9.28738C11.8918 9.28738 13.9796 7.20833 13.9796 4.64369C13.9796 2.07905 11.8918 0 9.31633 0C6.74087 0 4.65304 2.07905 4.65304 4.64369C4.65304 7.20833 6.74087 9.28738 9.31633 9.28738Z",
      fill: "#405369"
    }),
    React.createElement("path", {
      d: "M7.67555 22.2025L6.55691 19.5327C6.41981 19.1913 6.35161 18.8264 6.35613 18.4588C6.35766 18.0917 6.43274 17.7286 6.57702 17.3908C6.71919 17.0518 6.92895 16.7449 7.19358 16.4889C7.44771 16.2381 7.74951 16.0403 8.08129 15.9069L10.7603 14.789L11.8851 12.1232C11.9012 12.0872 11.9333 12.0632 11.9493 12.0292C11.1 11.7638 10.2165 11.6223 9.32643 11.6092C6.87158 11.6107 4.51649 12.5763 2.77221 14.2964C1.02794 16.0164 0.0354349 18.3522 0.0100514 20.7966H0V24.0584H6.89841L7.67555 22.2025Z",
      fill: "#405369"
    }),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M27.9474 25.6303L26.4934 22.2305L27.9334 18.8207C28.014 18.6289 28.0153 18.4131 27.9371 18.2203C27.8589 18.0275 27.7074 17.8732 27.5157 17.7908L24.1017 16.3569L22.6636 12.9191C22.5844 12.7286 22.4329 12.5769 22.2419 12.4971C22.0487 12.4193 21.8326 12.4193 21.6393 12.4971L18.1893 13.9311L14.7649 12.4971C14.5723 12.417 14.3557 12.4157 14.1621 12.4935C13.9685 12.5714 13.8133 12.7222 13.7306 12.9131L12.2908 16.3229L8.8545 17.7548C8.75799 17.7926 8.66988 17.849 8.59538 17.9208C8.52287 17.9936 8.46447 18.079 8.42279 18.1728C8.38301 18.2678 8.36248 18.3698 8.36248 18.4728C8.36248 18.5757 8.38301 18.6777 8.42279 18.7727L9.86062 22.2105L8.42279 25.6203C8.3429 25.8124 8.3429 26.0282 8.42279 26.2202C8.5019 26.4127 8.65309 26.5669 8.84445 26.6502L12.2587 28.0821L13.6966 31.5059C13.7346 31.603 13.792 31.6914 13.8652 31.7659C13.9378 31.8411 14.0254 31.9004 14.1224 31.9399C14.2186 31.9815 14.3227 32.002 14.4276 31.9999C14.5327 31.9997 14.6366 31.9779 14.7328 31.9359L18.1711 30.504L21.5852 31.9359C21.7784 32.0137 21.9945 32.0137 22.1877 31.9359C22.381 31.8585 22.5365 31.7093 22.6214 31.5199L24.0595 28.0961L27.4976 26.6642C27.6927 26.5844 27.8487 26.4314 27.9315 26.2382C28.017 26.0456 28.0226 25.8271 27.9474 25.6303ZM16.8838 26.3703L12.7949 22.2965H16.494L16.8958 22.6865L21.2618 18.3948L23.1115 20.2346L16.8838 26.3703Z",
      fill: "#405369"
    })
  );
}
SvgFeatureAgentProfile.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgFeatureAgentProfile"
};

function SvgFilledStar(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 13 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M5.877.679a.423.423 0 01.777 0l1.341 3.115c.061.142.196.24.35.254l3.377.313c.37.035.52.494.24.739L9.414 7.339a.423.423 0 00-.134.41l.746 3.31a.423.423 0 01-.628.456L6.48 9.783a.423.423 0 00-.432 0l-2.917 1.732a.423.423 0 01-.628-.456l.746-3.31a.423.423 0 00-.134-.41L.568 5.1a.423.423 0 01.24-.739l3.378-.313a.423.423 0 00.349-.254L5.877.68z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.488.511a.846.846 0 011.554 0l1.342 3.116 3.377.313a.846.846 0 01.48 1.478L9.694 7.657l.746 3.309a.846.846 0 01-1.257.913l-2.917-1.732-2.917 1.732a.846.846 0 01-1.257-.913l.746-3.31L.29 5.419a.846.846 0 01.48-1.478l3.378-.313L5.488.51zm.777.335L4.923 3.96a.846.846 0 01-.698.508l-3.378.313 2.548 2.24a.842.842 0 01.267.82l-.746 3.31L5.833 9.42a.846.846 0 01.864 0l2.917 1.732-.746-3.31a.846.846 0 01.267-.82l2.548-2.24-3.377-.313a.846.846 0 01-.7-.508L6.267.846z",
      fill: "currentColor"
    })
  );
}
SvgFilledStar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgFilledStar"
};

function SvgFilledVerify(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M12 5.726l-1.331-1.522.184-2.013-1.968-.446L7.853 0 6 .796 4.147 0 3.115 1.739l-1.969.44.185 2.018L0 5.727l1.331 1.521-.184 2.02 1.968.445 1.032 1.74L6 10.65l1.853.796 1.032-1.739 1.969-.446-.185-2.013L12 5.726zM8.803 4.39l-3.3 3.299a.603.603 0 01-.853 0L3.204 6.242a.473.473 0 010-.669.48.48 0 01.675 0l1.204 1.204L8.14 3.72a.485.485 0 01.669 0 .473.473 0 010 .669h-.006z",
      fill: "currentColor"
    })
  );
}
SvgFilledVerify.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgFilledVerify"
};

function SvgFocusOnPerson(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M4.5 1.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm2.625 1.875h-.266a2.06 2.06 0 01-1.718 0h-.266c-.621 0-1.125.504-1.125 1.125v2.438c0 .31.252.562.563.562h.375v2.438c0 .31.251.562.562.562h1.5c.31 0 .563-.252.563-.563V7.5h.375c.31 0 .562-.252.562-.563V4.5c0-.621-.504-1.125-1.125-1.125zm2.007 4.433a1.7 1.7 0 01-.68.633c.715.12 2.798.602 2.798 1.309 0 1.085-3.93 1.5-5.25 1.5-1.648 0-5.25-.489-5.25-1.5 0-.706 2.071-1.187 2.798-1.309a1.7 1.7 0 01-.68-.633C1.757 8.048 0 8.616 0 9.75 0 11.557 4.187 12 6 12c1.81 0 6-.442 6-2.25 0-1.134-1.757-1.702-2.868-1.942z",
      fill: "currentColor"
    })
  );
}
SvgFocusOnPerson.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgFocusOnPerson"
};

function SvgFullPage(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.066 3.065V.77a.766.766 0 111.533 0v3.06a.766.766 0 01-.767.768H.769a.767.767 0 110-1.534h2.297zm5.868 5.869v2.296a.766.766 0 11-1.533 0V8.168a.766.766 0 01.767-.769h3.063a.767.767 0 110 1.534H8.933zm-8.164 0h2.295v2.296a.767.767 0 101.533 0V8.166A.766.766 0 003.83 7.4H.77a.766.766 0 100 1.533zm8.165-5.868h2.295a.766.766 0 110 1.533H8.17a.766.766 0 01-.768-.767V.769a.767.767 0 111.534 0v2.297z",
      fill: "currentColor"
    })
  );
}
SvgFullPage.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgFullPage"
};

function SvgFullWidth(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.467 1.533H8.171a.766.766 0 110-1.533h3.061a.767.767 0 01.769.767V3.83a.767.767 0 11-1.534 0V1.532zm-8.934.001V3.83A.766.766 0 110 3.83V.769A.766.766 0 01.767 0H3.83a.767.767 0 110 1.533H1.532zm8.935 8.932V8.17a.766.766 0 111.533 0v3.061a.766.766 0 01-.767.768H8.17a.767.767 0 110-1.533h2.297zm-6.638 0H1.534V8.17A.767.767 0 100 8.17v3.062A.766.766 0 00.768 12H3.83a.766.766 0 100-1.533z",
      fill: "currentColor"
    })
  );
}
SvgFullWidth.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgFullWidth"
};

function SvgHamburger(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", { fill: "currentColor", d: "M0 1h12v2H0zm0 4h12v2H0zm0 4h12v2H0z" })
  );
}
SvgHamburger.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgHamburger"
};

function SvgHandDollarCardOutline(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none" }, props),
    React.createElement("path", {
      d: "M10.998 17.969h-5.06V3.019h10.01v7.676a1.7 1.7 0 01.976.65h.024V2.817a.8.8 0 00-.8-.8H5.738a.8.8 0 00-.8.8v15.35a.8.8 0 00.8.8h5.83a26.496 26.496 0 01-.57-.997z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M9.491 7.443c-.544-.264-.877-.443-.877-.782 0-.358.2-.539.6-.539a1.25 1.25 0 01.914.425l.128.118.742-.843-.107-.113a2.284 2.284 0 00-1.24-.72v-.913H8.599v.938a1.66 1.66 0 00-1.314 1.692c0 1.012.81 1.424 1.46 1.756.512.26.955.486.955.915 0 .4-.226.593-.69.593a1.943 1.943 0 01-1.208-.514l-.146-.115-.644.968.1.1c.417.37.931.613 1.482.7v.909h1.054v-.947a1.713 1.713 0 001.376-1.763c.004-1.121-.848-1.534-1.533-1.865zm3.904 12.576h5.066a3.335 3.335 0 00.542-1.721V13.67a.69.69 0 10-1.381 0v-.634a.691.691 0 00-.691-.69.684.684 0 00-.677.624l-.014-.638a.69.69 0 10-1.381 0V9.857a.691.691 0 00-1.381 0v6.9l-1.187-1.733a.756.756 0 00-1.081-.164.794.794 0 00-.175 1 39.057 39.057 0 002.36 4.159zm4.917.986h-4.689a.207.207 0 00-.207.207v.586c0 .114.093.207.207.207h4.689a.207.207 0 00.207-.207v-.586a.207.207 0 00-.207-.207z",
      fill: "currentColor"
    })
  );
}
SvgHandDollarCardOutline.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgHandDollarCardOutline"
};

function SvgHelp(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 13 13", fill: "none" }, props),
    React.createElement("path", {
      d: "M12.004 6.004a6.001 6.001 0 10-12.002.003 6.001 6.001 0 0012.002-.003zm-5.4 1.269H5.267v-.369c0-.325.069-.6.206-.84.137-.24.394-.488.754-.762.352-.249.583-.455.695-.609a.84.84 0 00.171-.531.576.576 0 00-.24-.498c-.163-.111-.386-.162-.677-.162-.497 0-1.072.162-1.714.488l-.549-1.097a4.785 4.785 0 012.374-.634c.695 0 1.243.171 1.646.497.411.334.609.78.609 1.328 0 .369-.078.686-.249.952-.163.274-.489.574-.951.908-.326.24-.523.42-.609.54a.863.863 0 00-.129.489v.3zm-1.26 2.349c-.154-.146-.231-.36-.231-.626 0-.283.069-.497.223-.643.154-.146.368-.214.66-.214.274 0 .488.077.643.223.154.145.231.36.231.634 0 .257-.077.471-.231.617-.155.154-.369.231-.643.231-.283 0-.497-.077-.652-.222z",
      fill: "currentColor"
    })
  );
}
SvgHelp.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgHelp"
};

function SvgHomeLine(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 14 13", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.918 6.762a.37.37 0 01.1.27.416.416 0 01-.112.269.583.583 0 01-.123.076.322.322 0 01-.135.03.392.392 0 01-.152-.03.291.291 0 01-.117-.088l-.504-.527v5.613a.36.36 0 01-.111.264.36.36 0 01-.264.111H8.875a.36.36 0 01-.264-.111.36.36 0 01-.111-.264v-3.75H5.512l-.012 3.75a.36.36 0 01-.111.264.36.36 0 01-.264.111H2.512a.37.37 0 01-.375-.375V6.762l-.504.527a.416.416 0 01-.27.111.369.369 0 01-.27-.1.416.416 0 01-.11-.269.369.369 0 01.099-.27L6.742.868a.399.399 0 01.13-.088.392.392 0 01.293 0 .29.29 0 01.116.088l5.637 5.895zm-1.793-.727c0-.015.004-.031.012-.047L7.012 1.676 2.875 5.988c0 .016.002.032.006.047a.192.192 0 01.006.047V12H4.75l.012-3.75a.36.36 0 01.111-.264.36.36 0 01.264-.111h3.738a.36.36 0 01.264.111.36.36 0 01.111.264V12h1.875V6.035z",
      fill: "currentColor"
    })
  );
}
SvgHomeLine.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgHomeLine"
};

function SvgHomePhoneNumber(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M11.658 8.48L9.033 7.355a.562.562 0 00-.657.161l-1.162 1.42a8.687 8.687 0 01-4.153-4.152l1.42-1.163a.561.561 0 00.162-.656L3.518.34a.566.566 0 00-.645-.326L.436.577A.563.563 0 000 1.125C0 7.137 4.873 12 10.875 12a.562.562 0 00.549-.436l.562-2.437a.569.569 0 00-.328-.647z",
      fill: "currentColor"
    })
  );
}
SvgHomePhoneNumber.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgHomePhoneNumber"
};

function SvgHouse(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 24 21", fill: "none" }, props),
    React.createElement("path", {
      d: "M13.812 11.909h-3.449a.996.996 0 00-.996.996v6.744c0 .55.446.996.996.996h3.45c.55 0 .995-.446.995-.996v-6.744a.996.996 0 00-.996-.996z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M23.706 8.986L12.43 1.03a.614.614 0 00-.714 0L.59 8.986a.625.625 0 00-.148.875.616.616 0 00.864.149l1.985-1.425v11.5a.625.625 0 00.625.625h16.261a.625.625 0 00.625-.625V8.46L23 10.01a.612.612 0 00.641.041.624.624 0 00.065-1.065zm-4.148 10.475H4.532V7.7l7.544-5.393 7.482 5.279V19.46z",
      fill: "currentColor"
    })
  );
}
SvgHouse.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgHouse"
};

function SvgInfo(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M11.625 6A5.625 5.625 0 11.375 6a5.625 5.625 0 0111.25 0z",
      stroke: "currentColor",
      strokeWidth: 0.75
    }),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.252 3.743a.85.85 0 00.248-.617.86.86 0 00-.248-.619.8.8 0 00-.596-.257.807.807 0 00-.6.257.857.857 0 00-.25.619c0 .241.083.447.25.617a.81.81 0 00.6.255.801.801 0 00.596-.255zm.063 5.626l.095-.428a1.567 1.567 0 01-.237.087c-.109.033-.207.05-.293.05-.183 0-.312-.033-.387-.1-.075-.066-.112-.192-.112-.376a4.012 4.012 0 01.112-.705l.355-1.385c.035-.127.058-.267.071-.42.013-.152.02-.258.02-.318 0-.293-.093-.53-.279-.712-.185-.183-.45-.274-.791-.274-.19 0-.392.037-.605.112a8.371 8.371 0 00-.669.269l-.095.428a3.69 3.69 0 01.249-.09.91.91 0 01.283-.048c.187 0 .314.035.38.105.066.07.1.194.1.372 0 .098-.01.207-.033.326a6.324 6.324 0 01-.08.378l-.355 1.39a4.552 4.552 0 00-.07.394 2.76 2.76 0 00-.021.34c0 .286.095.522.287.708.19.185.459.278.803.278.225 0 .422-.032.591-.098.17-.064.397-.159.681-.283z",
      fill: "currentColor"
    })
  );
}
SvgInfo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgInfo"
};

function SvgInsuranceDeductibleHurricane(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.968 8.79a.12.12 0 01.032.082v.894c0 .05-.031.094-.08.112l-5.756 2.093a.477.477 0 01-.329 0L.08 9.877A.121.121 0 010 9.764V8.87a.12.12 0 01.12-.12.11.11 0 01.04.008l.92.334V1.02C1.08.456 1.536 0 2.1 0h7.8c.564 0 1.02.456 1.02 1.02v8.072l.918-.334a.12.12 0 01.13.032zM8 5.8a2.05 2.05 0 00-1-1.771.331.331 0 01-.176-.228.343.343 0 01.063-.282c.32-.422.696-.8 1.113-1.119 0 0-4 0-4 3.4 0 .731.38 1.408 1 1.771a.331.331 0 01.176.228.343.343 0 01-.063.282c-.32.422-.696.8-1.113 1.119 0 0 4 0 4-3.4zm-1.529.48a.66.66 0 01-.942 0 .687.687 0 010-.96.66.66 0 01.942 0 .687.687 0 010 .96z",
      fill: "currentColor"
    })
  );
}
SvgInsuranceDeductibleHurricane.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgInsuranceDeductibleHurricane"
};

function SvgInsuranceDeductible(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.968 8.79a.12.12 0 01.032.082v.894c0 .05-.031.094-.08.112l-5.756 2.093a.477.477 0 01-.329 0L.08 9.877A.121.121 0 010 9.764V8.87a.12.12 0 01.12-.12.11.11 0 01.04.008l.92.334V1.02C1.08.456 1.536 0 2.1 0h7.8c.564 0 1.02.456 1.02 1.02v8.072l.918-.334a.12.12 0 01.13.032zm-6.224-.31v.8h.64v-.824c.4-.075.707-.24.92-.496.213-.261.32-.584.32-.968 0-.267-.053-.488-.16-.664a1.522 1.522 0 00-.408-.456 2.688 2.688 0 00-.52-.312 21.63 21.63 0 01-.528-.264 2.035 2.035 0 01-.4-.288.543.543 0 01-.16-.4c0-.208.061-.365.184-.472.123-.112.293-.168.512-.168.192 0 .357.037.496.112.139.07.283.173.432.312l.472-.536a2.447 2.447 0 00-.504-.4 1.543 1.543 0 00-.656-.224v-.8h-.64v.816c-.363.064-.65.221-.864.472-.213.245-.32.555-.32.928 0 .25.053.461.16.632.107.165.24.31.4.432.165.117.341.221.528.312.187.085.36.176.52.272.165.096.301.203.408.32a.63.63 0 01.16.44c0 .219-.064.39-.192.512-.128.117-.323.176-.584.176-.219 0-.424-.045-.616-.136a2.884 2.884 0 01-.568-.36l-.416.624c.181.17.395.31.64.416.25.101.499.165.744.192z",
      fill: "currentColor"
    })
  );
}
SvgInsuranceDeductible.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgInsuranceDeductible"
};

function SvgInsuranceLiability(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#insurance-liability_svg__a)" },
      React.createElement("path", {
        d: "M.9 1.2c-.496 0-.9.404-.9.9v1.2a.3.3 0 00.3.3h1.5V2.1c0-.496-.404-.9-.9-.9zm3.9 7.736V7.8h5.4V3c0-.993-.807-1.8-1.8-1.8H2.092c.19.251.308.561.308.9V9a1.2 1.2 0 001.402 1.184c.59-.096.998-.65.998-1.248zm.6-.536V9c0 .992-.807 1.8-1.8 1.8h6.3A2.1 2.1 0 0012 8.7a.3.3 0 00-.3-.3H5.4z",
        fill: "currentColor"
      })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "insurance-liability_svg__a" },
        React.createElement("path", { fill: "#fff", transform: "translate(0 1.2)", d: "M0 0h12v9.6H0z" })
      )
    )
  );
}
SvgInsuranceLiability.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgInsuranceLiability"
};

function SvgInsuranceProperty(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M1.8 3.69V2.4c0-.66.54-1.2 1.2-1.2h6c.66 0 1.2.54 1.2 1.2v1.296c-.696.246-1.2.906-1.2 1.686V6.6H3V5.376c0-.774-.504-1.44-1.2-1.686zm9 .51c-.66 0-1.2.54-1.2 1.2v1.8H2.4V5.4a1.2 1.2 0 00-2.4 0v3c0 .66.54 1.2 1.2 1.2v1.2h1.2V9.6h7.2v1.2h1.2V9.6c.66 0 1.2-.54 1.2-1.2v-3c0-.66-.54-1.2-1.2-1.2z",
      fill: "currentColor"
    })
  );
}
SvgInsuranceProperty.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgInsuranceProperty"
};

function SvgListing(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M12 6.926L9.75 4.704V1.37h-1.5v1.852L6 1 0 6.926v.37h1.5V11h3.75V8.778h1.5V11h3.75V7.296H12v-.37z",
      fill: "currentColor"
    })
  );
}
SvgListing.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgListing"
};

function SvgLoading(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M8.332 11.531A5.948 5.948 0 016 12a5.948 5.948 0 01-4.242-1.758A5.976 5.976 0 010 6c0-.117.04-.215.117-.293a.417.417 0 01.305-.129.38.38 0 01.293.129A.38.38 0 01.844 6c0 .703.136 1.371.41 2.004a5.055 5.055 0 001.101 1.64 5.216 5.216 0 001.641 1.114c.633.265 1.3.398 2.004.398a5 5 0 002.004-.41 5.055 5.055 0 001.64-1.101 5.216 5.216 0 001.114-1.641c.265-.633.398-1.3.398-2.004a5 5 0 00-.41-2.004 5.055 5.055 0 00-1.101-1.64 5.216 5.216 0 00-1.641-1.114A5.125 5.125 0 006 .844a.438.438 0 01-.305-.117.438.438 0 01-.117-.305c0-.117.04-.215.117-.293A.417.417 0 016 0a5.95 5.95 0 014.242 1.758A5.974 5.974 0 0112 6a5.948 5.948 0 01-1.758 4.242 5.975 5.975 0 01-1.91 1.29z",
      fill: "currentColor"
    })
  );
}
SvgLoading.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgLoading"
};

function SvgLock(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M10.274 4.888H9.239V3.362C9.239 1.512 7.786 0 5.996 0c-1.79 0-3.242 1.504-3.242 3.362v1.526H1.72a.715.715 0 0 0-.72.706v5.7c0 .388.324.706.719.706h8.562a.715.715 0 0 0 .719-.706v-5.7a.715.715 0 0 0-.719-.706h-.007zm-2.092 3.99c0 .156-.13.283-.288.283h-3.81a.286.286 0 0 1-.287-.283V7.96c0-.155.129-.283.287-.283h3.81c.158 0 .288.128.288.283v.918zm.33-3.99H3.467V3.362C3.466 1.9 4.602.706 5.989.706c1.388 0 2.524 1.194 2.524 2.656v1.526z",
      fill: "currentColor"
    })
  );
}
SvgLock.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgLock"
};

function SvgLogout(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M5.5 0v6h1V0h-1zM4 .344C1.673 1.169 0 3.394 0 6c0 3.309 2.692 6 6 6 3.309 0 6-2.691 6-6A6.012 6.012 0 008 .343v1.079c1.763.773 3 2.533 3 4.578 0 2.757-2.243 5-5 5S1 8.757 1 6a5.005 5.005 0 013-4.578V.344z",
      fill: "currentColor"
    })
  );
}
SvgLogout.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgLogout"
};

function SvgMagnifier(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M12 11.374L8.647 8.003a4.885 4.885 0 10-.644.644L11.373 12l.627-.626zM.897 4.894a3.997 3.997 0 117.994 0 3.997 3.997 0 01-7.994 0z",
      fill: "currentColor"
    })
  );
}
SvgMagnifier.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMagnifier"
};

function SvgMenuAcceptDeny(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M.64 12h.32V7.895H.64a.644.644 0 00-.453.185.627.627 0 00-.187.446v2.842c0 .168.067.329.187.447.12.119.283.185.453.185zm5.12-4.105H3.52l.359-1.064a.624.624 0 00-.315-.762A.647.647 0 003.272 6H3.2L1.6 7.717V12h3.52l1.252-2.715.028-.127v-.632a.627.627 0 00-.187-.446.644.644 0 00-.453-.185zM11.36 0h-.32v4.105h.32c.17 0 .333-.066.453-.185A.627.627 0 0012 3.474V.632a.627.627 0 00-.188-.447A.644.644 0 0011.36 0zM6.24 4.105h2.24L8.121 5.17a.624.624 0 00.315.762c.09.045.19.069.292.069H8.8l1.6-1.717V0H6.88L5.628 2.715l-.028.127v.632c0 .167.067.328.187.446.12.119.283.185.453.185z",
      fill: "currentColor"
    })
  );
}
SvgMenuAcceptDeny.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuAcceptDeny"
};

function SvgMenuEsignDoc(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.675 0l-8.12 7.771c.421.107.975.5 1.455 1.048.397.454.711.984.797 1.415l8.139-7.788.009.009s.013-.013.026-.042c.048-.118.073-.502-.856-1.474-.929-.972-1.314-.964-1.432-.92L9.675 0zM1.116 8.685l-.088.295-.408 1.367c.149.01.268.127.314.179.093.108.142.23.134.335v.002h-.001l1.43-.168.313-.036.421-.05.013.002a.384.384 0 00.062.008c.03 0 .07-.005.093-.025.03-.026.044-.082.041-.161-.01-.257-.207-.765-.725-1.356-.538-.615-1.11-.947-1.374-.947-.027 0-.062.004-.08.02l-.001.002c-.029.025-.04.083-.034.164l-.11.369zM.568 10.57a.048.048 0 01.032-.01l.007.002c.045.004.108.043.163.106.07.08.097.166.07.203l-.002.004c0 .002 0 .004-.002.005l-.352.294a.37.37 0 01-.184.046c-.053 0-.104-.012-.134-.046-.074-.086.012-.278.05-.31l.352-.294zm-.38 1.055a.188.188 0 000 .375h5.624a.188.188 0 000-.375H.188z",
      fill: "currentColor"
    })
  );
}
SvgMenuEsignDoc.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuEsignDoc"
};

function SvgMenuExplore(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 6A6 6 0 110 6a6 6 0 0112 0zM7.326 7.464l2.437-5.2-5.197 2.44-.008-.006-.006.013-.013.007.007.007-2.263 5.02 5.024-2.26.006.006.006-.012.015-.007-.008-.008zM8.848 3.18L7.18 6.74l-.946-.94-.943-.95 3.557-1.67z",
      fill: "currentColor"
    })
  );
}
SvgMenuExplore.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuExplore"
};

function SvgMenuFeedback(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 14 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M13 2.687L10.725 4.06M13 8.179l-2.275-1.373M13 5.433h-2.275",
      stroke: "currentColor",
      strokeWidth: 0.687,
      strokeLinecap: "round"
    }),
    React.createElement("path", {
      clipRule: "evenodd",
      d: "M4.894 7.77l-.768.91s-1.734-.36-1.982-.825c-.248-.464 0-.996 0-.996l2.75.91z",
      stroke: "currentColor",
      strokeWidth: 0.687,
      strokeLinejoin: "round"
    }),
    React.createElement("path", {
      clipRule: "evenodd",
      d: "M8.32 8.865c-.432 0-.78-1.537-.78-3.432C7.54 3.537 7.887 2 8.32 2c.43 0 .78 1.537.78 3.433 0 1.895-.35 3.432-.78 3.432z",
      stroke: "currentColor",
      strokeWidth: 0.687
    }),
    React.createElement("path", {
      d: "M8.343 2l-7.26 2.712C1.01 5.18 1 5.3 1 5.432c0 .143.016.502.084 1.01l7.259 2.423",
      stroke: "currentColor",
      strokeWidth: 0.687,
      strokeLinejoin: "round"
    })
  );
}
SvgMenuFeedback.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuFeedback"
};

function SvgMenuInsurance(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M.75 1.766C4.065 1.646 6 0 6 0s1.935 1.645 5.25 1.766c0 0 .024 9.049-5.25 10.234C.702 10.815.75 1.766.75 1.766zm6.16 5.537l1.086.54a.908.908 0 01.504.813V9h-5v-.367c0-.332.182-.638.475-.797l1.014-.55a.412.412 0 00.216-.363V6.51s-.298-.354-.411-.847a.34.34 0 01-.158-.285v-.452c0-.1.045-.19.114-.251V4.02S4.615 3 6 3s1.25 1.019 1.25 1.019v.655c.07.062.114.15.114.25v.453a.34.34 0 01-.242.323 2.483 2.483 0 01-.44.81v.424c0 .156.088.299.229.369z",
      fill: "currentColor"
    })
  );
}
SvgMenuInsurance.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuInsurance"
};

function SvgMenuInviteEarn(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.575 6.762a.846.846 0 01.089-.004l.008-.005c.036-.024.046-.03.08-.138.041-.135-.028-.453-.028-.453a4.346 4.346 0 01-.102-.107c-.088-.097-.127-.287-.16-.447a.832.832 0 00-.071-.244.451.451 0 00-.066-.07c-.08-.073-.19-.174-.302-.54-.147-.484-.326-1.175-.136-1.186a.137.137 0 01.055.01.366.366 0 00-.018-.065.505.505 0 01-.025-.098 2.782 2.782 0 00-.066-.278 2.017 2.017 0 01-.08-.375c-.02-.391.082-1.496.312-1.865.231-.368.593-.68 1.109-.79.452-.098 1.79-.181 2.213 0 .142.06.316.148.491.255.291.178.583.406.728.636.232.368.3 1.372.278 1.764a7.78 7.78 0 01-.119.878c.054-.046.107-.075.153-.072.19.011.01.702-.137 1.186-.11.365-.222.467-.301.54-.026.024-.048.044-.066.07a.775.775 0 00-.071.244c-.033.16-.072.35-.16.447a11.95 11.95 0 01-.097.101l-.026.416c-.009.145.039.155.08.164.02.005.037.008.048.024a.26.26 0 01.038.002c.063.03.158.087.286.162.12.07.267.158.446.257-.226.302-.346.71-.372 1.119-.035.517.262 1.197 1.164 1.747-.247 0-.641.072-.792.263-.09.114-.16.273-.188.364-.053.16-.175.543-.184.576H7.113l-.5-2.173c.273-.497.42-1.128.42-1.128s-.316-.104-.667-.104c-.414 0-.653.104-.653.104s.08.533.372 1.128l-.499 2.173H.175c-.536 0 .292-2.59.726-2.726 1.348-.422 2.633-1.166 3.286-1.545.183-.106.316-.183.388-.217zm6.47 1.953c.283.107.565.214.83.351.91.468 1.154 1.53.524 2.253-.23.264-.53.439-.882.528-.154.037-.222.112-.216.26.007.097.005.193.002.29a6.506 6.506 0 00-.002.147c0 .132-.07.201-.21.204a14.17 14.17 0 01-.505 0c-.148-.003-.216-.08-.22-.215v-.16c-.002-.053-.002-.106-.002-.159-.003-.235-.01-.247-.253-.281a3.339 3.339 0 01-.898-.241c-.222-.1-.247-.152-.182-.37.047-.164.093-.325.148-.485.062-.187.114-.21.3-.12.311.151.647.237.996.277.225.026.444.006.654-.08.388-.158.45-.577.12-.83a1.655 1.655 0 00-.373-.203c-.101-.04-.204-.079-.306-.117a5.055 5.055 0 01-.715-.308c-.525-.29-.858-.691-.818-1.282.044-.672.45-1.088 1.11-1.312l.012-.004c.26-.088.263-.089.263-.349v-.091c-.001-.06-.002-.12 0-.179.006-.198.043-.232.256-.238a2.272 2.272 0 01.198 0c.231-.001.345-.002.4.054.054.054.055.16.056.368 0 .299 0 .301.321.347.244.035.478.104.706.195.124.052.17.132.133.256-.056.184-.111.367-.173.548-.061.172-.12.198-.296.118a2.377 2.377 0 00-1.12-.207.95.95 0 00-.299.057c-.339.138-.394.485-.105.7.149.11.315.19.488.256l.059.022z",
      fill: "currentColor"
    })
  );
}
SvgMenuInviteEarn.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuInviteEarn"
};

function SvgMenuListing(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M10.287 7.002c0-.015 0-.03-.007-.045L6 3.43 1.72 6.957c0 .015-.007.03-.007.045v3.573c0 .26.216.476.476.476h2.858V8.193h1.906v2.858H9.81a.48.48 0 00.476-.476V7.002zm1.66-.513a.244.244 0 00-.03-.335l-1.63-1.355V1.762a.235.235 0 00-.238-.238h-1.43a.235.235 0 00-.237.238v1.452L6.566 1.695a.917.917 0 00-1.132 0L.083 6.154a.244.244 0 00-.03.335l.462.55a.248.248 0 00.156.082.254.254 0 00.179-.052L6 2.775l5.15 4.294a.233.233 0 00.157.052h.022a.248.248 0 00.156-.082l.462-.55z",
      fill: "currentColor"
    })
  );
}
SvgMenuListing.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuListing"
};

function SvgMenuMessages(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 5.441c0 2.591-2.686 4.691-6 4.691a4.962 4.962 0 01-1.986-.437l-3.32.805.815-1.948S0 7.5 0 5.442C0 2.85 2.686.75 6 .75s6 2.1 6 4.691zM3.75 5.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM6 6a.75.75 0 100-1.5A.75.75 0 006 6zm3.75-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
      fill: "currentColor"
    })
  );
}
SvgMenuMessages.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuMessages"
};

function SvgMenuOtherDocs(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.445 0C1.647 0 1 .647 1 1.445v9.11C1 11.353 1.647 12 2.445 12h6.403c.798 0 1.445-.647 1.445-1.445V2.983L7.457 0H2.445zm7.576 2.996H8.889a1.445 1.445 0 01-1.445-1.445V.281l2.577 2.715zM8.5 5h-6v1h6V5zm-6 2h6v1h-6V7zm3 2h-3v1h3V9z",
      fill: "currentColor"
    })
  );
}
SvgMenuOtherDocs.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuOtherDocs"
};

function SvgMenuPro(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.428.001a.543.543 0 01.579.574L12 .69a7.126 7.126 0 01-2.73 5.278l-.546.425V7.69a4.016 4.016 0 01-1.174 2.85l-1.38 1.39a.234.234 0 01-.402-.155l-.15-2.955-.609.31s-.69.345-.857.42a.883.883 0 00-.036.016.246.246 0 01-.113.036.234.234 0 01-.1-.023A3.081 3.081 0 012.43 8.1a.238.238 0 01.032-.253l.408-.854.286-.635L.23 6.206a.238.238 0 01-.154-.404l1.382-1.39a3.973 3.973 0 012.84-1.181l1.35.04.516-.639A7.087 7.087 0 0111.209.015l.219-.014zM6.78 5.625a.375.375 0 11-.75 0 .375.375 0 01.75 0zm1.584-.913a1.073 1.073 0 10-.002-2.145 1.073 1.073 0 00.002 2.145zm.655-1.068a.65.65 0 11-1.299.001.65.65 0 011.299 0zm-8.205 7.42s-.208-.587.12-1.307c.327-.721.695-1.136.695-1.136s.386.73.655 1c.268.268.973.629.973.629s-.408.392-1.107.677c-.7.286-1.336.137-1.336.137z",
      fill: "currentColor"
    })
  );
}
SvgMenuPro.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuPro"
};

function SvgMenuRefChecks(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 13", fill: "none" }, props),
    React.createElement("path", {
      d: "M9.167 8.956l-1.971-1a.764.764 0 01-.416-.683V6.49c.066-.078.128-.159.186-.243.265-.382.472-.804.613-1.253a.626.626 0 00.44-.597v-.838a.628.628 0 00-.207-.464v-1.21S8.057 0 5.542 0C3.024 0 3.27 1.884 3.27 1.884v1.21a.628.628 0 00-.207.464v.838c0 .22.114.415.286.527a4.18 4.18 0 00.746 1.566v.765c0 .279-.15.536-.392.67l-1.84 1.018A1.68 1.68 0 001 10.416v.678h9.082v-.637c0-.636-.354-1.217-.915-1.502z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M8.591 12C9.921 12 11 10.864 11 9.463c0-1.4-1.079-2.537-2.409-2.537-1.33 0-2.41 1.136-2.41 2.537S7.262 12 8.592 12z",
      fill: "currentColor",
      stroke: "#fff",
      strokeWidth: 0.332
    }),
    React.createElement("path", {
      d: "M7.558 9.837l.584.714.955-1.168.527-.644",
      stroke: "#fff",
      strokeWidth: 0.332,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  );
}
SvgMenuRefChecks.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuRefChecks"
};

function SvgMenuRentCollection(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 6A6 6 0 110 6a6 6 0 0112 0zM7.242 4.488a.177.177 0 00.118-.06l.458-.52a.18.18 0 00-.013-.251 2.247 2.247 0 00-1.11-.61.182.182 0 01-.149-.176v-.608a.18.18 0 00-.18-.18h-.54a.18.18 0 00-.18.18v.635a.182.182 0 01-.138.173c-.79.213-1.272.824-1.272 1.684 0 .95.794 1.354 1.478 1.702.517.263.971.494.971.906 0 .426-.232.64-.751.64-.397 0-.764-.148-1.174-.429a.18.18 0 00-.255.048l-.406.627a.178.178 0 00.035.236c.4.3.866.498 1.359.58a.18.18 0 01.153.178v.593a.18.18 0 00.18.18h.54a.18.18 0 00.18-.18V9.19a.181.181 0 01.136-.173c.866-.238 1.311-.9 1.311-1.747 0-1.04-.842-1.444-1.539-1.778-.491-.236-.91-.437-.91-.802 0-.418.241-.594.686-.594.329.003.645.13.885.354a.177.177 0 00.127.038z",
      fill: "currentColor"
    })
  );
}
SvgMenuRentCollection.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuRentCollection"
};

function SvgMenuRentEst(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.125 1.29c0-.712.578-1.29 1.29-1.29H7.77l2.918 2.983v7.727A1.29 1.29 0 019.398 12H2.415a1.29 1.29 0 01-1.29-1.29V1.29zm7.922 1.706h1.09L7.756.541v1.165c0 .712.577 1.29 1.29 1.29zm-2.899.754H4.174l.577.596c-.518.832-1.22 1.573-2.073 2.065-.103.06-.043.22.068.192C3.79 6.345 4.797 5.84 5.52 5.141l.627.648V3.75zm-2.023 4.5h-1.5v2.25h1.5V8.25zm.75-1.5h1.5v3.75h-1.5V6.75zm3.75-2.25h-1.5v6h1.5v-6z",
      fill: "currentColor"
    })
  );
}
SvgMenuRentEst.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuRentEst"
};

function SvgMenuScreening(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.39 0c-.698 0-1.265.567-1.265 1.265v9.47c0 .698.567 1.265 1.265 1.265h7.22c.698 0 1.265-.567 1.265-1.265V2.983L7.9 0H2.39zm6.007 9.189l-1.354-.662a.504.504 0 01-.285-.451v-.52a2.07 2.07 0 00.128-.16c.184-.255.324-.535.42-.83a.417.417 0 00.302-.394v-.554a.41.41 0 00-.141-.308v-.8s.168-1.247-1.56-1.247-1.56 1.246-1.56 1.246v.801a.41.41 0 00-.141.308v.554c0 .146.079.274.196.348.142.603.513 1.037.513 1.037v.506a.503.503 0 01-.27.443l-1.264.674a1.107 1.107 0 00-.593.975v.449h6.238v-.421c0-.421-.243-.806-.629-.994zm.755-6.193h1.161L7.886.541v1.19c0 .699.567 1.265 1.266 1.265z",
      fill: "currentColor"
    })
  );
}
SvgMenuScreening.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuScreening"
};

function SvgMenuShareReport(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.445 0C1.647 0 1 .647 1 1.445v9.11C1 11.353 1.647 12 2.445 12h6.403c.798 0 1.445-.647 1.445-1.445V2.983L7.457 0H2.445zm7.576 2.996H8.889a1.445 1.445 0 01-1.445-1.445V.281l2.577 2.715zM6.159 6.25a4.72 4.72 0 00-.204.004c-1.357.048-2.534.79-3.104 1.903a3.26 3.26 0 00-.133.29l-.001.003a3.098 3.098 0 00-.1.29l-.002.003a3.39 3.39 0 00-.115.591c1.53-1.801 3.853-1.39 3.878-1.385l.15.028v1.157l1.06-.905L9 7.024 6.527 5v1.257l-.19-.005a6.067 6.067 0 00-.178-.003z",
      fill: "currentColor"
    })
  );
}
SvgMenuShareReport.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuShareReport"
};

function SvgMenuSuggest(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.722 4.2a3.66 3.66 0 01-1.045 2.565 3.38 3.38 0 00-.913 1.84.614.614 0 01-.61.515H4.846a.608.608 0 01-.606-.512 3.417 3.417 0 00-.92-1.846 3.666 3.666 0 01-1.038-2.521A3.697 3.697 0 015.977.506C8.043.491 9.722 2.151 9.722 4.201zm-1.999 5.908v.438a.697.697 0 01-.593.689l-.109.398a.498.498 0 01-.482.367H5.461a.498.498 0 01-.482-.367l-.106-.398a.7.7 0 01-.596-.692v-.438c0-.235.19-.423.425-.423h2.596a.428.428 0 01.425.426zM6.002 1.546a.416.416 0 110 .833 1.842 1.842 0 00-1.847 1.834.42.42 0 01-.42.417.418.418 0 01-.419-.417 2.679 2.679 0 012.686-2.667z",
      fill: "currentColor"
    })
  );
}
SvgMenuSuggest.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuSuggest"
};

function SvgMenuSupport(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.25.75A2.25 2.25 0 000 3v4.617a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0012 7.617V3A2.25 2.25 0 009.75.75h-7.5zm3.52 9.117L5.08 12 8.8 9.867H5.77zm-1.266-7.03a2.93 2.93 0 01.324-.257 2.298 2.298 0 011.34-.405c.251 0 .48.036.688.108.207.072.384.175.532.308.148.134.262.295.343.484.081.189.122.4.122.635 0 .228-.032.425-.096.591a1.645 1.645 0 01-.24.435 1.95 1.95 0 01-.316.319l-.321.254c-.102.08-.19.158-.263.234a.468.468 0 00-.132.259l-.1.657H5.65l-.074-.733a.207.207 0 01-.005-.039V5.65c0-.132.032-.247.096-.344a1.36 1.36 0 01.239-.275c.095-.085.198-.168.308-.25a2.79 2.79 0 00.309-.263 1.32 1.32 0 00.239-.321.89.89 0 00.036-.714.654.654 0 00-.162-.22.723.723 0 00-.25-.142.972.972 0 00-.315-.05 1.357 1.357 0 00-.71.183c-.08.046-.147.088-.202.126a.272.272 0 01-.148.056.236.236 0 01-.226-.135l-.282-.463zm.87 4.536a.714.714 0 00-.05.265c0 .096.018.185.05.268a.641.641 0 00.611.407.648.648 0 00.604-.407.683.683 0 00.052-.268.688.688 0 00-.4-.625.635.635 0 00-.517 0 .636.636 0 00-.35.36z",
      fill: "currentColor"
    })
  );
}
SvgMenuSupport.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuSupport"
};

function SvgMenuSyndicate(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 14 13", fill: "none" }, props),
    React.createElement("path", {
      fill: "currentColor",
      d: "M3.118 1.667h.706V3h-.706zm7.059 0h.706V3h-.706z"
    }),
    React.createElement("path", {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 0.75,
      strokeLinejoin: "round",
      d: "M2.412 3.25h9.176v9H2.412z"
    }),
    React.createElement("path", {
      d: "M9.27 8.524c0-.008 0-.016-.004-.024L7 6.56 4.734 8.5c0 .008-.004.016-.004.024v1.964a.26.26 0 00.253.262h1.513V9.179h1.008v1.571h1.513a.259.259 0 00.253-.262V8.524zm.878-.282a.138.138 0 00-.015-.184l-.863-.745V5.644a.127.127 0 00-.126-.13h-.757a.127.127 0 00-.126.13v.798l-.962-.835a.471.471 0 00-.598 0L3.867 8.058a.138.138 0 00-.015.184l.244.303a.13.13 0 00.083.045.131.131 0 00.094-.029L7 6.201l2.727 2.36a.12.12 0 00.082.029h.012a.13.13 0 00.083-.045l.244-.303z",
      fill: "#fff"
    }),
    React.createElement("path", {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 0.667,
      strokeLinejoin: "round",
      d: "M1 1h12v.667H1z"
    })
  );
}
SvgMenuSyndicate.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMenuSyndicate"
};

function SvgMoreHorizontal(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.5 4.5C.673 4.5 0 5.173 0 6s.673 1.5 1.5 1.5S3 6.827 3 6s-.673-1.5-1.5-1.5zm9 0C9.673 4.5 9 5.173 9 6s.673 1.5 1.5 1.5S12 6.827 12 6s-.673-1.5-1.5-1.5zM4.5 6c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5S6.827 7.5 6 7.5 4.5 6.827 4.5 6z",
      fill: "currentColor"
    })
  );
}
SvgMoreHorizontal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMoreHorizontal"
};

function SvgMoreVertical(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.75 1.5c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5S5.423 3 6.25 3s1.5-.673 1.5-1.5zm0 8.76a1.501 1.501 0 00-3 0c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5zm-1.5-5.88c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5z",
      fill: "currentColor"
    })
  );
}
SvgMoreVertical.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgMoreVertical"
};

function SvgNotify(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M2.566 1.933l-.769-.775C0 2.943 0 4.238 0 5.91h.545l.546-.034c0-1.597 0-2.477 1.475-3.942zm7.636-.775l-.768.775c1.475 1.465 1.475 2.345 1.475 3.976L12 5.875c0-1.638 0-2.932-1.798-4.717zM6 11.91a1.626 1.626 0 001.537-1.09H4.463A1.625 1.625 0 006 11.908zm3.818-4.044V5.364a3.822 3.822 0 00-2.806-3.678A1.086 1.086 0 006 1c-.461 0-.852.284-1.012.686a3.82 3.82 0 00-2.806 3.678v2.501l-.931.931a.543.543 0 00-.16.386v.545a.546.546 0 00.545.546h8.728a.545.545 0 00.545-.546v-.545a.544.544 0 00-.16-.386l-.93-.93z",
      fill: "currentColor"
    })
  );
}
SvgNotify.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgNotify"
};

function SvgPdfLine(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M1.375.82c0-.246.2-.445.445-.445h5.819l2.764 2.763v8.042c0 .246-.2.445-.445.445H1.82a.445.445 0 01-.445-.445V.82z",
      stroke: "currentColor",
      strokeWidth: 0.75
    }),
    React.createElement("path", {
      d: "M3 9.453h.435v-.9h.39c.525 0 .93-.252.93-.796 0-.57-.394-.757-.93-.757H3v2.453zm.435-1.25V7.35h.353c.356 0 .54.101.54.409 0 .3-.173.446-.54.446h-.353zm1.77 1.25h.675c.727 0 1.173-.424 1.173-1.238C7.053 7.405 6.607 7 5.857 7h-.652v2.453zM5.64 9.1V7.353h.187c.495 0 .78.262.78.862 0 .604-.285.885-.78.885H5.64zm1.901.353h.435V8.428h.889V8.06h-.889v-.694h1.046V7H7.541v2.453z",
      fill: "currentColor"
    })
  );
}
SvgPdfLine.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgPdfLine"
};

function SvgPersonHouseOutline(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none" }, props),
    React.createElement("path", {
      d: "M9.825 9.771a2.892 2.892 0 100-5.784 2.892 2.892 0 000 5.784zm2.243 7.064a1.24 1.24 0 01-.658-2.245l2.432-1.743a5.777 5.777 0 00-9.8 4.064v1.116h8.026v-1.192z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M16.462 13.431l2.4 1.72v3.789h-4.794v-3.8l2.391-1.714.003.005zm-.003-1.179a.24.24 0 00-.14.045l-4.327 3.1a.238.238 0 00.141.434h.935v3.821a.283.283 0 00.282.282h6.228a.281.281 0 00.282-.282v-3.821h.93a.237.237 0 00.195-.1.241.241 0 00-.056-.336l-4.33-3.1a.24.24 0 00-.14-.045v.002z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M17.149 16.553h-1.37a.391.391 0 00-.391.391v2.605a.39.39 0 00.391.391h1.37a.391.391 0 00.391-.391v-2.605a.391.391 0 00-.391-.391z",
      fill: "currentColor"
    })
  );
}
SvgPersonHouseOutline.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgPersonHouseOutline"
};

function SvgPerson(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 28",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    React.createElement("path", {
      d: "M11.995 2.21a4.145 4.145 0 11-4.147 4.147 4.152 4.152 0 014.147-4.147zm0-1.667a5.812 5.812 0 10.004 11.624A5.812 5.812 0 0011.995.543zm0 14.832a9.99 9.99 0 019.94 9.795v.565H2.055v-.551a10 10 0 019.942-9.809h-.002zm.002-1.666A11.614 11.614 0 00.39 25.157l-.018 2.245h23.25l-.019-2.245a11.613 11.613 0 00-11.606-11.448z",
      fill: "currentColor"
    })
  );
}
SvgPerson.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgPerson"
};

function SvgPhone(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.469.44C2.169.72 2 1.101 2 1.5v9c0 .398.169.78.469 1.06.3.282.707.44 1.131.44h4.8c.424 0 .831-.158 1.131-.44.3-.28.469-.662.469-1.06v-9c0-.398-.169-.78-.469-1.06C9.231.157 8.824 0 8.4 0H3.6c-.424 0-.831.158-1.131.44zm4.097 8.78c.15.14.234.331.234.53s-.084.39-.234.53A.828.828 0 016 10.5a.828.828 0 01-.566-.22.727.727 0 01-.234-.53c0-.199.084-.39.234-.53A.828.828 0 016 9c.212 0 .416.079.566.22zM4.2 1.5a1 1 0 00-1 1v4.75a1 1 0 001 1h3.6a1 1 0 001-1V2.5a1 1 0 00-1-1H4.2z",
      fill: "currentColor"
    })
  );
}
SvgPhone.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgPhone"
};

function SvgPlay(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M11.625 6A5.625 5.625 0 11.375 6a5.625 5.625 0 0111.25 0z",
      stroke: "currentColor",
      strokeWidth: 0.75
    }),
    React.createElement("path", {
      d: "M4.74 4.174L7.784 6 4.74 7.826V4.174z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 0.48,
      strokeLinejoin: "round"
    })
  );
}
SvgPlay.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgPlay"
};

function SvgPrint(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.462 0h5.076a1.618 1.618 0 011.6 1.385H1.862A1.618 1.618 0 013.462 0zM1.673 1.846h8.712A1.616 1.616 0 0112 3.462v4.615a1.616 1.616 0 01-1.615 1.615h-.231v1.145A1.163 1.163 0 018.99 12H3.009a1.163 1.163 0 01-1.163-1.163V9.692h-.23A1.615 1.615 0 010 8.077V3.519a1.673 1.673 0 011.673-1.673zm7.487 9.16a.241.241 0 00.07-.17V6.24A.24.24 0 008.99 6H3.01a.24.24 0 00-.24.24v4.597a.241.241 0 00.24.24h5.98a.24.24 0 00.17-.07zm.416-6.485a.692.692 0 10.699-1.196.692.692 0 00-.699 1.196z",
      fill: "currentColor"
    })
  );
}
SvgPrint.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgPrint"
};

function SvgRcmMovesIn(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.424 2L8.173 3.251a2 2 0 00-.092 2.732l.09.096 1.414 1.415a2 2 0 002.298.382L12 7.813v4.854h1.333a.666.666 0 01.078 1.328l-.078.005H2.667a.667.667 0 01-.078-1.329l.078-.004V3.333A1.333 1.333 0 013.9 2.003L4 2h5.424zM9 8.667a1 1 0 100 2 1 1 0 000-2zm1.529-5.886a.666.666 0 01.998.88l-.056.063-.275.275h2.137a.667.667 0 01.078 1.329l-.078.004h-2.14l.278.278a.667.667 0 01-.88.997l-.064-.055-1.413-1.415a.667.667 0 01-.055-.88l.056-.063 1.413-1.413z",
      fill: "currentColor"
    })
  );
}
SvgRcmMovesIn.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgRcmMovesIn"
};

function SvgRedo(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M11.714 0h-1.128a.285.285 0 00-.285.3l.095 1.968A5.887 5.887 0 005.9.19 5.912 5.912 0 000 6.096a5.9 5.9 0 009.855 4.376.286.286 0 00.011-.415l-.808-.809a.285.285 0 00-.39-.013 4.172 4.172 0 01-2.767 1.044A4.185 4.185 0 011.713 6.09a4.185 4.185 0 014.188-4.188c1.449 0 2.724.735 3.476 1.852l-2.416-.116a.286.286 0 00-.299.285v1.128c0 .158.128.286.286.286h4.766A.286.286 0 0012 5.052V.286A.286.286 0 0011.714 0z",
      fill: "currentColor"
    })
  );
}
SvgRedo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgRedo"
};

function SvgRentPaymentOutline(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M6 .667A5.333 5.333 0 11.667 6 5.34 5.34 0 016 .667zM6 0a6 6 0 106 6 6.007 6.007 0 00-6-6z",
      fill: "currentColor"
    }),
    React.createElement("path", {
      d: "M6.365 5.526c-.439-.212-.818-.396-.818-.755 0-.36.214-.548.6-.548a1.185 1.185 0 01.858.396l.063.058.571-.649-.052-.055a1.943 1.943 0 00-1.12-.63v-.8h-.8v.82A1.413 1.413 0 004.501 4.81c0 .857.667 1.2 1.259 1.499.475.241.885.45.885.873 0 .395-.23.595-.681.595a1.788 1.788 0 01-1.115-.472l-.071-.055-.499.748.052.049c.374.331.838.545 1.333.612v.8h.8v-.827a1.461 1.461 0 001.221-1.51c.006-.954-.729-1.31-1.32-1.596z",
      fill: "currentColor"
    })
  );
}
SvgRentPaymentOutline.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgRentPaymentOutline"
};

function SvgReview(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M11.493.7H.52a.51.51 0 00-.513.514v8.32a.51.51 0 00.513.513h3.5v1.707c0 .16.173.253.307.166l2.96-1.88h4.2A.51.51 0 0012 9.527V1.214A.51.51 0 0011.487.7h.006zM6.391 4.938l-1.024.742a.294.294 0 00-.107.327l.413 1.28c.087.267-.22.493-.446.327l-1.08-.787a.29.29 0 00-.34 0l-1.08.787c-.227.166-.534-.054-.447-.327l.413-1.28c.04-.12 0-.253-.106-.327L1.5 4.887a.291.291 0 01.173-.527h1.34c.127 0 .24-.08.28-.2l.414-1.28c.086-.266.466-.266.553 0l.413 1.28c.04.12.154.2.28.2h1.34c.28 0 .4.36.174.527l-.076.05zm3.896 2.056h-2.62a.33.33 0 01-.334-.334.33.33 0 01.334-.333h2.62a.33.33 0 01.333.333.33.33 0 01-.333.334zm0-2.687h-2.62a.33.33 0 01-.334-.333.33.33 0 01.334-.334h2.62a.33.33 0 01.333.334.33.33 0 01-.333.333z",
      fill: "currentColor"
    })
  );
}
SvgReview.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgReview"
};

function SvgSavePdf(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.584 0C1.985 0 1.5.485 1.5 1.084v9.832c0 .599.485 1.084 1.084 1.084h7.125c.599 0 1.084-.485 1.084-1.084V2.983L7.957 0H2.584zm7.937 2.996H9.028a1.084 1.084 0 01-1.084-1.084V.281l2.577 2.715zM3.464 9.75h.435v-.9h.39c.525 0 .93-.251.93-.795 0-.57-.394-.758-.93-.758h-.825V9.75zm.435-1.249v-.855h.352c.356 0 .54.101.54.409 0 .3-.172.446-.54.446h-.352zm1.77 1.249h.674c.728 0 1.174-.424 1.174-1.238 0-.81-.446-1.215-1.196-1.215h-.653V9.75zm.434-.353V7.65h.188c.495 0 .78.262.78.862 0 .604-.285.885-.78.885h-.188zm2.337.353h-.435V7.297h1.48v.368H8.44v.694h.888v.367H8.44V9.75z",
      fill: "currentColor"
    })
  );
}
SvgSavePdf.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgSavePdf"
};

function SvgShare(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M6.379 3.885a9.95 9.95 0 01.706-.002l.35.01V1.5L12 5.353 9.393 7.646 7.435 9.368V7.165l-.276-.053C7.113 7.102 2.823 6.32 0 9.75a6.58 6.58 0 01.213-1.126l.002-.006A6.02 6.02 0 01.4 8.066l.002-.005a6.71 6.71 0 01.245-.553C1.7 5.39 3.874 3.978 6.38 3.885z",
      fill: "currentColor"
    })
  );
}
SvgShare.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgShare"
};

function SvgSuccess(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M3.919 8.711L1.177 6.046 0 7.191 3.919 11 12 3.144 10.823 2 3.919 8.711z",
      fill: "currentColor"
    })
  );
}
SvgSuccess.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgSuccess"
};

function SvgSwitch(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M5.81 10.532v-.011L4.69 8.83a.29.29 0 00-.39-.094l-.097.059c-.065.03-.1.086-.103.164a.346.346 0 00.054.211l.719 1.08a.223.223 0 00-.061-.017 2.184 2.184 0 01-.067-.012.22.22 0 01-.055-.018 4.5 4.5 0 01-2.18-1.238 4.689 4.689 0 01-.742-1.004c-.585-1.088-.682-2.215-.292-3.382.089-.282.209-.55.359-.804s.323-.491.517-.71c.195-.22.412-.42.652-.6.24-.18.497-.34.773-.48a.367.367 0 00.183-.212.33.33 0 00-.025-.276.369.369 0 00-.219-.182.35.35 0 00-.28.024A5.538 5.538 0 001.774 2.6 4.85 4.85 0 00.757 4.356 4.884 4.884 0 00.52 6.358c.06.677.254 1.321.578 1.932.35.65.82 1.203 1.413 1.661a5.274 5.274 0 001.984.957c.009.008.017.012.025.012h.024l-.986.493a.234.234 0 00-.128.153c-.02.07-.01.136.03.2l.037.093c.09.141.207.176.353.106l1.814-.904.122-.059a.276.276 0 00.128-.164.233.233 0 00-.03-.2l-.074-.106zm5.078-6.786a5.274 5.274 0 00-1.394-1.662 5.11 5.11 0 00-1.967-.957 2.435 2.435 0 00-.316-.07l.974-.47A.292.292 0 008.33.423a.244.244 0 00-.012-.2L8.282.13A.297.297 0 008.038 0a.475.475 0 00-.145.024L6.078.928l-.121.058a.246.246 0 00-.098.364l.061.118h.012l1.12 1.69a.288.288 0 00.17.124c.074.02.143.01.208-.03l.097-.058a.191.191 0 00.11-.165.317.317 0 00-.049-.211l-.718-1.08c.178.023.333.055.463.094.178.047.353.101.523.164a3.7 3.7 0 01.493.223 4.87 4.87 0 01.877.61c.134.118.26.243.377.376a4.87 4.87 0 01.615.869c.585 1.088.682 2.216.293 3.382a4.368 4.368 0 01-.865 1.515c-.39.446-.856.806-1.4 1.08a.367.367 0 00-.183.211.345.345 0 00.024.282.34.34 0 00.33.2.373.373 0 00.182-.047 5.206 5.206 0 001.631-1.25c.455-.521.788-1.11.999-1.768.438-1.307.345-2.58-.28-3.816l-.061-.117z",
      fill: "currentColor"
    })
  );
}
SvgSwitch.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgSwitch"
};

function SvgTag(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M0 5.909V1.125C0 .504.504 0 1.125 0h4.784c.298 0 .585.119.796.33l4.966 4.965c.439.44.439 1.152 0 1.591l-4.785 4.785a1.124 1.124 0 01-1.59 0L.33 6.705A1.125 1.125 0 010 5.909zM2.625 1.5a1.125 1.125 0 100 2.25 1.125 1.125 0 000-2.25z",
      fill: "currentColor"
    })
  );
}
SvgTag.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgTag"
};

function SvgTrash(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M1.286 10.875c0 .298.124.585.345.796.22.21.52.329.833.329h7.072c.312 0 .612-.118.833-.33a1.1 1.1 0 00.345-.795V3H1.286v7.875zm6.678-6c0-.1.042-.195.115-.265a.403.403 0 01.556 0c.074.07.115.166.115.265v5.25c0 .1-.041.195-.115.265a.403.403 0 01-.556 0 .367.367 0 01-.115-.265v-5.25zm-2.357 0c0-.1.042-.195.115-.265a.403.403 0 01.556 0c.073.07.115.166.115.265v5.25c0 .1-.042.195-.115.265a.403.403 0 01-.556 0 .367.367 0 01-.115-.265v-5.25zm-2.357 0c0-.1.041-.195.115-.265a.403.403 0 01.556 0c.073.07.115.166.115.265v5.25c0 .1-.042.195-.115.265a.403.403 0 01-.556 0 .367.367 0 01-.115-.265v-5.25zM11.107.75H8.161L7.93.312a.573.573 0 00-.218-.228.61.61 0 00-.31-.084H4.596a.603.603 0 00-.31.084.566.566 0 00-.216.228L3.84.75H.892a.403.403 0 00-.278.11.367.367 0 00-.115.265v.75c0 .1.041.195.115.265.074.07.174.11.278.11h10.214c.104 0 .204-.04.278-.11a.367.367 0 00.115-.265v-.75c0-.1-.041-.195-.115-.265a.402.402 0 00-.278-.11z",
      fill: "currentColor"
    })
  );
}
SvgTrash.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgTrash"
};

function SvgUser(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M6 0C2.747 0 0 2.747 0 6s2.747 6 6 6 6-2.747 6-6-2.747-6-6-6zm0 3c1.036 0 1.8.763 1.8 1.8S7.036 6.6 6 6.6s-1.8-.763-1.8-1.8S4.964 3 6 3zM2.936 8.863A2.976 2.976 0 015.4 7.543h1.2c1.028 0 1.925.528 2.464 1.32a4.181 4.181 0 01-6.128 0z",
      fill: "currentColor"
    })
  );
}
SvgUser.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgUser"
};

function SvgWarning(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M6.536 7.536V5.34H5.464v2.196h1.072zm0 2.17V8.608H5.464v1.098h1.072zM0 11.34L6 1l6 10.34H0z",
      fill: "currentColor"
    })
  );
}
SvgWarning.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgWarning"
};

function SvgChatboxStarLines(props) {
  return React.createElement(
    "svg",
    _babelHelpers._extends({ width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none" }, props),
    React.createElement("path", {
      d: "M11.4933 0.700195H0.519925C0.233258 0.700195 0.0065918 0.926862 0.0065918 1.21353V9.53353C0.0065918 9.8202 0.233258 10.0469 0.519925 10.0469H4.01992V11.7535C4.01992 11.9135 4.19326 12.0069 4.32659 11.9202L7.28659 10.0402H11.4866C11.7733 10.0402 11.9999 9.81353 11.9999 9.52686V1.21353C11.9999 0.926862 11.7733 0.700195 11.4866 0.700195H11.4933ZM6.39055 4.9377L5.36659 5.6802C5.26659 5.75353 5.21992 5.88686 5.25992 6.00686L5.67326 7.28686C5.75992 7.55353 5.45326 7.7802 5.22659 7.61353L4.14659 6.82686C4.04659 6.75353 3.90659 6.75353 3.80659 6.82686L2.72659 7.61353C2.49992 7.7802 2.19326 7.5602 2.27993 7.28686L2.69326 6.00686C2.73326 5.88686 2.69326 5.75353 2.58659 5.6802L1.49993 4.88686C1.27326 4.7202 1.38659 4.3602 1.67326 4.3602H3.01326C3.13993 4.3602 3.25326 4.2802 3.29326 4.1602L3.70659 2.8802C3.79326 2.61353 4.17326 2.61353 4.25992 2.8802L4.67326 4.1602C4.71326 4.2802 4.82659 4.3602 4.95326 4.3602H6.29326C6.57326 4.3602 6.69326 4.7202 6.46659 4.88686L6.39055 4.9377ZM10.2866 6.99353H7.66659C7.47992 6.99353 7.33326 6.84686 7.33326 6.6602C7.33326 6.47353 7.47992 6.32686 7.66659 6.32686H10.2866C10.4733 6.32686 10.6199 6.47353 10.6199 6.6602C10.6199 6.84686 10.4733 6.99353 10.2866 6.99353ZM10.2866 4.30686H7.66659C7.47992 4.30686 7.33326 4.1602 7.33326 3.97353C7.33326 3.78686 7.47992 3.6402 7.66659 3.6402H10.2866C10.4733 3.6402 10.6199 3.78686 10.6199 3.97353C10.6199 4.1602 10.4733 4.30686 10.2866 4.30686Z",
      fill: "currentColor"
    })
  );
}
SvgChatboxStarLines.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgChatboxStarLines"
};



var Icons = /*#__PURE__*/Object.freeze({
  AccountCcpa: SvgAccountCcpa,
  AccountEmailPref: SvgAccountEmailPref,
  AccountLink: SvgAccountLink,
  AccountPassword: SvgAccountPassword,
  AccountProfile: SvgAccountProfile,
  Account: SvgAccount,
  Add: SvgAdd,
  ArrowRotateRightDollarOutline: SvgArrowRotateRightDollarOutline,
  ArrowsRotateOutline: SvgArrowsRotateOutline,
  BankAccount: SvgBankAccount,
  BirthdayGift: SvgBirthdayGift,
  BusinessContact: SvgBusinessContact,
  CaretDown: SvgCaretDown,
  CaretLeft: SvgCaretLeft,
  CaretRight: SvgCaretRight,
  CaretUp: SvgCaretUp,
  Check: SvgCheck,
  ChevronDown: SvgChevronDown,
  ChevronLeft: SvgChevronLeft,
  ChevronRight: SvgChevronRight,
  ChevronUp: SvgChevronUp,
  Clock: SvgClock,
  Close: SvgClose,
  Company: SvgCompany,
  ContactAdd: SvgContactAdd,
  ContactAdded: SvgContactAdded,
  CreditCard: SvgCreditCard,
  DocCar: SvgDocCar,
  DocContact: SvgDocContact,
  DocHome: SvgDocHome,
  DocImage: SvgDocImage,
  DocMagnifier: SvgDocMagnifier,
  DocPdf: SvgDocPdf,
  DocPlain: SvgDocPlain,
  DocProgress: SvgDocProgress,
  DocUpload: SvgDocUpload,
  Download: SvgDownload,
  Edit: SvgEdit,
  Email: SvgEmail,
  EmptyStar: SvgEmptyStar,
  EmptyVerify: SvgEmptyVerify,
  Error: SvgError,
  EsignCalendar: SvgEsignCalendar,
  EsignCheckbox: SvgEsignCheckbox,
  EsignInitials: SvgEsignInitials,
  EsignText: SvgEsignText,
  FaWarning: SvgFaWarning,
  FeatureReferenceChecks: SvgFeatureReferenceChecks,
  FeatureRentEstimates: SvgFeatureRentEstimates,
  FeatureRentersInsurance: SvgFeatureRentersInsurance,
  FeatureRequestDocs: SvgFeatureRequestDocs,
  FeatureSuggestFeature: SvgFeatureSuggestFeature,
  FeatureTenantScreening: SvgFeatureTenantScreening,
  FeatureListingPage: SvgFeatureListingPage,
  FeatureClientManager: SvgFeatureClientManager,
  FeatureAgentProfile: SvgFeatureAgentProfile,
  FilledStar: SvgFilledStar,
  FilledVerify: SvgFilledVerify,
  FocusOnPerson: SvgFocusOnPerson,
  FullPage: SvgFullPage,
  FullWidth: SvgFullWidth,
  Hamburger: SvgHamburger,
  HandDollarCardOutline: SvgHandDollarCardOutline,
  Help: SvgHelp,
  HomeLine: SvgHomeLine,
  HomePhoneNumber: SvgHomePhoneNumber,
  House: SvgHouse,
  Info: SvgInfo,
  InsuranceDeductibleHurricane: SvgInsuranceDeductibleHurricane,
  InsuranceDeductible: SvgInsuranceDeductible,
  InsuranceLiability: SvgInsuranceLiability,
  InsuranceProperty: SvgInsuranceProperty,
  Listing: SvgListing,
  Loading: SvgLoading,
  Lock: SvgLock,
  Logout: SvgLogout,
  Magnifier: SvgMagnifier,
  MenuAcceptDeny: SvgMenuAcceptDeny,
  MenuEsignDoc: SvgMenuEsignDoc,
  MenuExplore: SvgMenuExplore,
  MenuFeedback: SvgMenuFeedback,
  MenuInsurance: SvgMenuInsurance,
  MenuInviteEarn: SvgMenuInviteEarn,
  MenuListing: SvgMenuListing,
  MenuMessages: SvgMenuMessages,
  MenuOtherDocs: SvgMenuOtherDocs,
  MenuPro: SvgMenuPro,
  MenuRefChecks: SvgMenuRefChecks,
  MenuRentCollection: SvgMenuRentCollection,
  MenuRentEst: SvgMenuRentEst,
  MenuScreening: SvgMenuScreening,
  MenuShareReport: SvgMenuShareReport,
  MenuSuggest: SvgMenuSuggest,
  MenuSupport: SvgMenuSupport,
  MenuSyndicate: SvgMenuSyndicate,
  MoreHorizontal: SvgMoreHorizontal,
  MoreVertical: SvgMoreVertical,
  Notify: SvgNotify,
  PdfLine: SvgPdfLine,
  PersonHouseOutline: SvgPersonHouseOutline,
  Person: SvgPerson,
  Phone: SvgPhone,
  Play: SvgPlay,
  Print: SvgPrint,
  RcmMovesIn: SvgRcmMovesIn,
  Redo: SvgRedo,
  RentPaymentOutline: SvgRentPaymentOutline,
  Review: SvgReview,
  SavePdf: SvgSavePdf,
  Share: SvgShare,
  Success: SvgSuccess,
  Switch: SvgSwitch,
  Tag: SvgTag,
  Trash: SvgTrash,
  User: SvgUser,
  Warning: SvgWarning,
  ChatboxStarLines: SvgChatboxStarLines
});

var defaultSize = function defaultSize(size) {
  var sizing = {
    sm: 12,
    md: 16,
    lg: 20,
    xl: 24
  };
  return sizing[size] || null;
};

var generateSize = function generateSize() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "sm";

  var result = defaultSize(size);
  if (result) {
    return result;
  }
  if (parseInt(size, 10) > 32) {
    return 12;
  }
  return 16 * parseInt(size, 10);
};

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"], ["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n    animation: ", " 2s linear infinite;\n  "], ["\n    animation: ", " 2s linear infinite;\n  "]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  height: ", "px;\n  width: ", "px;\n  padding: 0;\n  color: ", ";\n  ", "\n  ", "\n  \n  & > svg {\n    ", "\n    transition: all 250ms linear;\n  }\n\n  &.flip > svg {\n    transform: rotate(180deg);\n  }\n\n  ", "\n"], ["\n  position: relative;\n  display: inline-block;\n  height: ", "px;\n  width: ", "px;\n  padding: 0;\n  color: ", ";\n  ", "\n  ", "\n  \n  & > svg {\n    ", "\n    transition: all 250ms linear;\n  }\n\n  &.flip > svg {\n    transform: rotate(180deg);\n  }\n\n  ", "\n"]);

var rotate = styled.keyframes(_templateObject);
var animation = function animation() {
  return styled.css(_templateObject2, rotate);
};

var Container = styled__default.div(_templateObject3, function (props) {
  return props.size && props.size;
}, function (props) {
  return props.size && props.size;
}, function (props) {
  return props.color ? props.color : "inherit";
}, function (props) {
  return props.size && "font-size: " + props.size + "px;";
}, function (props) {
  return props.margin && "margin: " + props.margin + ";";
}, function (props) {
  return props.spin && animation;
}, function (props) {
  return props.mSize && "\n  @media (max-width: 991px) {\n    height: " + props.mSize + "px;\n    width: " + props.mSize + "px;\n    font-size: " + props.mSize + "px;\n  }\n  ";
});

var parseIconNameToMatchJSFile = function parseIconNameToMatchJSFile(iconName) {
  return upperFirst(camelCase(iconName));
};

var Icon = function (_React$Component) {
  _babelHelpers.inherits(Icon, _React$Component);

  function Icon() {
    _babelHelpers.classCallCheck(this, Icon);
    return _babelHelpers.possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _babelHelpers.createClass(Icon, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          icon = _props.icon,
          name = _props.name,
          icons = _props.icons,
          color = _props.color,
          size = _props.size,
          spin = _props.spin,
          mSize = _props.mSize,
          margin = _props.margin,
          props = _babelHelpers.objectWithoutProperties(_props, ["icon", "name", "icons", "color", "size", "spin", "mSize", "margin"]);

      var IconComponent = Icons[parseIconNameToMatchJSFile(icon || name)];

      return React__default.createElement(
        Container,
        _babelHelpers._extends({
          color: color,
          size: generateSize(size),
          mSize: mSize && generateSize(mSize),
          spin: spin,
          margin: margin
        }, props),
        IconComponent ? React__default.createElement(IconComponent, {
          style: {
            position: "absolute",
            height: "1em",
            width: "1em",
            left: "0",
            top: "0"
          }
        }) : React__default.createElement("div", null)
      );
    }
  }]);
  return Icon;
}(React__default.Component);

Icon.propTypes = {
  /** The icon name: you can passing icon name to use the icon */
  icon: PropTypes.string.isRequired,
  /** This is icon name if you not passing 'icon' props it will use this instead */
  name: PropTypes.string,
  /** Icon color */
  color: PropTypes.string,
  /** Icon size: For UI system recommend to use sm, md, lg and xl instead pixel */
  size: PropTypes.string,
  /** Set it true if you need spin icon. e.g. for the loading icon. */
  spin: PropTypes.bool,
  /** Icon mobile size: For UI system recommend to use sm, md, lg and xl instead pixel */
  mSize: PropTypes.string,
  /** The margin for Icon */
  margin: PropTypes.string
};
Icon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Icon",
  "props": {
    "icon": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "The icon name: you can passing icon name to use the icon"
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "This is icon name if you not passing 'icon' props it will use this instead"
    },
    "color": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Icon color"
    },
    "size": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Icon size: For UI system recommend to use sm, md, lg and xl instead pixel"
    },
    "spin": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set it true if you need spin icon. e.g. for the loading icon."
    },
    "mSize": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Icon mobile size: For UI system recommend to use sm, md, lg and xl instead pixel"
    },
    "margin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The margin for Icon"
    }
  }
};

exports.Icon = Icon;
//# sourceMappingURL=icon.js.map
